export const DICTIONARY = [
    /* АРХАИЗМНАР (АРХАИЗМЫ) */
    {
        id: "1",
        type: "TYPE_ARCH",
        lines: [ 2021, 5354],
        text: "Амнах",
        translate: "өллөххө кэтэр таҥас, өлүнньүк таҥас (посмертная одежда)"
        },
        {
        id: "2",
        type: "TYPE_ARCH",
        lines: [ 4332  ],
        text: "Аҥаабыллаа",
        translate: "айа кирсин аппаччы тарт (тетиву широко натягивать)"
        },
        {
        id: "3",
        type: "TYPE_ARCH",
        lines: [ 143 ],
        text: "Боҕуска",
        translate: "туох эмэ оҥоһукка, саха таҥаһыгар тигиллэр, биитэр иҥиннэриллэр киэргэл (украшение, отделка якутского наряда или какого-либо изделия)."
        },
        {
        id: "4",
        type: "TYPE_ARCH",
        lines: [ 479 ],
        text: "Далла",
        translate: "кыра кээмэйдээх ураһа (малая ураса)"
        },
        {
        id: "5",
        type: "TYPE_ARCH",
        lines: [ 5319 ],
        text: "Дьабыыл = дьабыл",
        translate: "төрөөбөтөх, оҕоломмотох (не рожавшая)"
        },
        {
        id: "6",
        type: "TYPE_ARCH",
        lines: [ 3000 ],
        text: "Дьаҕа",
        translate: "туох эмэ саҕата, кытыыта (край, окраина чего-л.)"
        },
        {
        id: "7",
        type: "TYPE_ARCH",
        lines: [ 309 ],
        text: "Дьуолка",
        translate: "улахан айан суолун бэлиэтэ (вешка, знак на большой дороге)"
        },
        {
        id: "8",
        type: "TYPE_ARCH",
        lines: [ 4169 ],
        text: "Дьуорсун",
        translate: "үрдүк, маһа суох сир (возвышенная, без деревьев)"
        },
        {
        id: "9",
        type: "TYPE_ARCH",
        lines: [ 1445 ],
        text: "Дьэс",
        translate: "кыһыл алтантан оҥоһуллубут (медный, отлитый из красной меди)"
        },
        {
        id: "10",
        type: "TYPE_ARCH",
        lines: [ 1370, 2499, 5696 ],
        text: "Идэмэр",
        translate: "иҥсэ, обот (жадность, алчность)"
        },
        {
        id: "11",
        type: "TYPE_ARCH",
        lines: [ 1850, 6018 ],
        text: "Ини-бии",
        translate: "бииргэ төрөөбүт убайдыы быраат (родные братья)"
        },
        {
        id: "12",
        type: "TYPE_ARCH",
        lines: [ 1821  ],
        text: "Көй киин",
        translate: "ханнык эмэ сир саамай киинэ (сердцевина)"
        },
        {
        id: "13",
        type: "TYPE_ARCH",
        lines: [ 4464 ],
        text: "Кулан дьорҕоот",
        translate: "туохтан да, кимтэн да чаҕыйан турбат дохсун, кэлиилээх-барыылаах. (смелый, отважный, храбрый, ничего не боящийся, резвый, бурный)"
        },
        {
        id: "14",
        type: "TYPE_ARCH",
        lines: [ 4912 ],
        text: "Күөкэримэ",
        translate: "уһун (длинный)"
        },
        {
        id: "15",
        type: "TYPE_ARCH",
        lines: [ 5877 ],
        text: "Кэҥсэ",
        translate: "кыра аһылыкка сөп буолбат, элбэҕи сиир-аһыыр (ненасытный, прорва, обжора)"
        },
        {
        id: "16",
        type: "TYPE_ARCH",
        lines: [ 928, 1056 ],
        text: "Нөрүөн (мөрүөҥ)",
        translate: "киһи курданарыттан үөһээ өттө: түөһэ, сиһэ уо.д.а. (верхняя часть туловища)"
        },
        {
        id: "17",
        type: "TYPE_ARCH",
        lines: [ 317, 2173, 5027 ],
        text: "Нуоҕай",
        translate: "бэргэһэ оройуттан намылыйан дугалыы түспүт куорсун эбэтэр түү (перо, висящее дугой на верхушке, макушке шапки)"
        },
        {
        id: "18",
        type: "TYPE_ARCH",
        lines: [ 5504 ],
        text: "Одулуун = одуруун",
        translate: "оллур-боллур, бөлтөҕөр (неровность, бугристость)"
        },
        {
        id: "19",
        type: "TYPE_ARCH",
        lines: [ 814, 1896, 2496, 4809, 5386 ],
        text: "Оппуос",
        translate: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)"
        },
        {
        id: "20",
        type: "TYPE_ARCH",
        lines: [ 2963 ],
        text: "Ороһулаа",
        translate: "хойутаан төрөө (поздно родиться)"
        },
        {
        id: "21",
        type: "TYPE_ARCH",
        lines: [ 1935  ],
        text: "Оруоска",
        translate: "буруйдааҕы таһыйарга анаан эрдэ быһан ыаннарыллыбыт талах эбэтэр быа кымньыы (розга)"
        },
        {
        id: "22",
        type: "TYPE_ARCH",
        lines: [ 4249  ],
        text: "Өтөҕөлөөбүт",
        translate: "биир сиргэ өрөһөлүү мунньубут (скопить в одном месте кучей, бугром)"
        },
        {
        id: "23",
        type: "TYPE_ARCH",
        lines: [ 6466 ],
        text: "Саҕаһа",
        translate: "оһох уотун уматарга туттуллар тымтык (лучина для разведения огня)"
        },
        {
        id: "24",
        type: "TYPE_ARCH",
        lines: [ 517 ],
        text: "Сатанах",
        translate: "былыр дьиэҕэ, дьиэ таһыгар туруорар ону-маны иилэ быраҕан ыйыырга аналлаах үөһээ өттүгэр сараҕар мутуктардаах баҕана (в старину: столб в якутской юрте или во дворе перед домом из бревна, на котором в верхней части оставлены обрезанные сучья для вешания грубых вещей, старинная вешалка)"
        },
        {
        id: "25",
        type: "TYPE_ARCH",
        lines: [ 5115 ],
        text: "Сах",
        translate: "куһаҕан саҥнаах күүс, тыын (недобрая сила, недобрый дух)"
        },
        {
        id: "26",
        type: "TYPE_ARCH",
        lines: [ 378 ],
        text: "Суҥ иһэгэй",
        translate: "сүөһү түүлээбит түүтэ иирсибитэ, мөчөхтөспүтэ (свалявшийся, спутанный комок шерсти от линьки животных)"
        },
        {
        id: "27",
        type: "TYPE_ARCH",
        lines: [ 441 ],
        text: "Сыҥсаар",
        translate: "сыыҥка эбэтэр сындалҕаннаах дьарҕа ыарыы, арҕах (цинга или изнуряющая хроническая болезнь)"
        },
        {
        id: "28",
        type: "TYPE_ARCH",
        lines: [ 6673 ],
        text: "Сэлиэнэй",
        translate: "чэй иһэр иһит, чааскы (чашка (фарфоровая))"
        },
        {
        id: "29",
        type: "TYPE_ARCH",
        lines: [ 1266 ],
        text: "Тоҕус хараҕалаах",
        translate: "тоҕус кииннээх (с девятью стержнями)"
        },
        {
        id: "30",
        type: "TYPE_ARCH",
        lines: [ 956, 3972 ],
        text: "Тыҥ",
        translate: "сарсыарда күн тахсарын саҕана халлааҥҥа үөскүүр синньигэс сырдык балаһа (рассвет, утренняя заря)"
        },
        {
        id: "31",
        type: "TYPE_ARCH",
        lines: [ 2381 ],
        text: "Үөттүрэх",
        translate: "уоту булкуйар мас (кочерга)"
        },
        {
        id: "32",
        type: "TYPE_ARCH",
        lines: [ 2201, 5363  ],
        text: "Хаҥырҕас",
        translate: "халыгырас-кылыгырас тыастаах тиэрбэс киэргэл, аарык (предмет украшения в виде металлических колечек, побрякивающий, позвякивающий при встряхивании)"
        },
        {
        id: "33",
        type: "TYPE_ARCH",
        lines: [ 3779 ],
        text: "Хаппар куҥа",
        translate: "өрөҕөтүн кытта тардыһан холбоһор сирин, быттыгын ис куҥа, буут иһэ (ляжка). Куҥ – сүөһү көп этэ (мясо без костей, мякоть)"
        },
        {
        id: "34",
        type: "TYPE_ARCH",
        lines: [ 3786, 3580 ],
        text: "Хаппахчы",
        translate: "саха балаҕаныгар эдэр ыалга, кыыска анаммыт кыракый хос (в якутской юрте место для спанья молодой девушки или молодоженов)"
        },
        {
        id: "35",
        type: "TYPE_ARCH",
        lines: [ 917 ],
        text: "Хордоҕой",
        translate: "сыһыыга уһун ньолбуһах кураанах кыра кирбии (небольшой сухой вытянутый пригорок на поляне, бугор)"
        },
        {
        id: "36",
        type: "TYPE_ARCH",
        lines: [  ],
        text: "Чиэски",
        translate: "уһук сиргэ баар, ыраах, туора турар (находящийся вдали от центра, окраинный, глухой)"
        },
        {
        id: "37",
        type: "TYPE_ARCH",
        lines: [ 738 ],
        text: "Чомпу сүлүгэс = чомпо сүллүгэс",
        translate: "болтоҕор төбөлөөх, кылгас уктаах, былыр кыргыһыыга туттуллар мас тэрил (боевая дубина с короткой рукоятью)"
        },
        {
        id: "38",
        type: "TYPE_ARCH",
        lines: [ 1303 ],
        text: "Чыллырыыт",
        translate: "балык хатырыга (чешуя)"
        },
        {
        id: "39",
        type: "TYPE_ARCH",
        lines: [ 4172 ],
        text: "Эндэр",
        translate: "куһаҕан, аҥхайдаах-куоһахтаах, оллур-боллур, айанныырга эрэйдээх (плохая, с рытвинами, выбоинами, трудная)"
        },
        {
        id: "40",
        type: "TYPE_ARCH",
        lines: [ 939, 3828 ],
        text: "Эргэнэ хара тыа",
        translate: "бөдөҥ мастаах халыҥ ойуур, сис тыа (густой лес с крупными деревьями)"
        },
        {
        id: "41",
        type: "TYPE_ARCH",
        lines: [ 1447 ],
        text: "Эт бэргэ харах",
        translate: "кытарбыт үрүҥнээх, уулаах-хаардаах, чэмэлкэйэ суох харах (красноватые, воспаленные глаза)"
        },
        
    /* ИСТОРИЗМНАР (ИСТОРИЗМЫ) */
    {
        id: "42",
        type: "TYPE_HIST",
        lines: [ 462 ],
        text: "Аҕа ууһа",
        translate: "биир өбүгэлэртэн төрүттээх, хас да ийэ ууһун холбуур улахан уус (род, происходящий из нескольких ийэ ууһа, большая семья: основная единица якутского самоуправления)"
        },
        {
        id: "43",
        type: "TYPE_HIST",
        lines: [ 1374 ],
        text: "Адаҕа",
        translate: "ыар буруйдаахтарга кэтэрдэр ыарахан мас боҕуу; хандалы (арестантские колодки; кандалы)"
        },
        {
        id: "44",
        type: "TYPE_HIST",
        lines: [ 222 ],
        text: "Амнах",
        translate: "өлбүт киһи сирэйин сабыыта (покрывало на лицо мертвого человека)"
        },
        {
        id: "45",
        type: "TYPE_HIST",
        lines: [ 215 ],
        text: "Араҥас илгэ",
        translate: "былыргы өйдөбүлүнэн үөһээ айыылартан бэриллэр үрүҥ ас-үөл, үүт-арыы дэлэйиитэ (по старинному поверью, изобилие молочных продуктов, ниспосланное добрыми духами)"
        },
        {
        id: "46",
        type: "TYPE_HIST",
        lines: [ 436 ],
        text: "Арбаҕас",
        translate: "түүтэ элэйбит, холто буолан эрэр саҕынньах (облезлая ветхая доха с полинявшим мехом)"
        },
        {
        id: "47",
        type: "TYPE_HIST",
        lines: [ 1436 ],
        text: "Арбыйа",
        translate: "дүлүҥү хаһан тыыны, мас иһити оҥорорго аналлаах былыргы туттар сэп (инструмент древних якутов для долбления лодок, деревянной посуды)"
        },
        {
        id: "48",
        type: "TYPE_HIST",
        lines: [ 375 ],
        text: "Ардьаах",
        translate: "сонос соҕус мастарынан өрүллүбүт собоҕо уонна атын бөдөҥ балыкка аналлаах туу (Большая верша, морда для ловли карася и другой крупной рыбы)"
        },
        {
        id: "49",
        type: "TYPE_HIST",
        lines: [ 1600  ],
        text: "Атыйах",
        translate: "уу кутарга эбэтэр балыкка аналлаах намыһах туос иһит (берестяное лукошко, предназначенное для воды или хранения рыбы)"
        },
        {
        id: "50",
        type: "TYPE_HIST",
        lines: [ 679 ],
        text: "Балтарык",
        translate: "сыарҕаҕа тиэллэн иһэр оту туттарар, баттатар уһун ураҕас (шест, которым при перевозке стягиваются снопы сена на возу)"
        },
        {
        id: "51",
        type: "TYPE_HIST",
        lines: [ 267 ],
        text: "Батас",
        translate: "көнө өнчөхтөөх, мөтөгөр биилээх былыргы сэрии сэбэ (древнее воинское оружие: пальма с прямой спинкой и дугообразной лезвией)"
        },
        {
        id: "52",
        type: "TYPE_HIST",
        lines: [ 622, 1870, 3790, 3370, 6555 ],
        text: "Биллэрик",
        translate: "саха балаҕаныгар киирэр ааны утары эркиҥҥэ сыста турар наара орон (лавка, расположенная вдоль противоположной стены от входа в якутскую юрту)"
        },
        {
        id: "53",
        type: "TYPE_HIST",
        lines: [ 2058  ],
        text: "Биһиэйэх = бадьаа",
        translate: "улахан мас хамыйах (большой деревянный ковш)"
        },
        {
        id: "54",
        type: "TYPE_HIST",
        lines: [ 5558 ],
        text: "Болгуо",
        translate: "былыргы саха уустара уруудаттан уһааран ылар тимирдэрин сомоҕото (железные болванки, получаемые путем сплава руды древними якутскими кузнецами"
        },
        {
        id: "55",
        type: "TYPE_HIST",
        lines: [ 1541  ],
        text: "Болот",
        translate: "икки өттүнэн биилээх токур соҕус уһун тимирдээх, кылгас уктаах сэрии сэбэ (обоюдоострый выгнутый меч с короткой рукояткой)"
        },
        {
        id: "56",
        type: "TYPE_HIST",
        lines: [ 1559 ],
        text: "Боппууда",
        translate: "урукку ыйааһын кээмэйэ, аҕыс киилэ кэриҥэ (старая мера веса, равная примерно 8 кг, полпуда)"
        },
        {
        id: "57",
        type: "TYPE_HIST",
        lines: [ 734 ],
        text: "Буут",
        translate: "урукку ыйааһын кээмэйэ: 16 киилэ 380 кыраам (старая русская мера массы, пуд)"
        },
        {
        id: "58",
        type: "TYPE_HIST",
        lines: [ 669 ],
        text: "Былас",
        translate: "уста кээмэйэ: туора уунуллубут илиилэр тарбахтарын төбөтүттэн нөҥүө тарбахтарын төбөлөрүгэр диэри (маховая сажень, размах обеих рук)"
        },
        {
        id: "59",
        type: "TYPE_HIST",
        lines: [ 1302 ],
        text: "Быһычча",
        translate: "кыра быһах (ножик)"
        },
        {
        id: "60",
        type: "TYPE_HIST",
        lines: [ 4043 ],
        text: "Бэлкэй",
        translate: "саамай кыра чороон (самый маленький деревянный сосуд)"
        },
        {
        id: "61",
        type: "TYPE_HIST",
        lines: [ 665, 1652 ],
        text: "Бэчээтинэй",
        translate: "саһаан устата (2,13 м) (печатная (казенная, мерная) сажень (2,13 м))"
        },
        {
        id: "62",
        type: "TYPE_HIST",
        lines: [ 1237 ],
        text: "Дапсылҕа",
        translate: "охсор, дайбыыр сэп-сэбиргэл (орудие или оружие, которым можно размахнуться, ударить)"
        },
        {
        id: "63",
        type: "TYPE_HIST",
        lines: [ 3793 ],
        text: "Дуобаттаах суорҕан",
        translate: "дуобат хараҕын курдук араас өҥнөөх лоскуйдартан аттарыллыбыт суорҕан (клетчатое одеяло, сшитое из равных по размеру разноцветных лоскутков, похожее рисунком на шашечную доску)"
        },
        {
        id: "64",
        type: "TYPE_HIST",
        lines: [ 5031 ],
        text: "Дүҥүр",
        translate: " ойуун кыырарыгар былаайаҕынан охсон тыаһатар тэрилэ (шаманский бубен)"
        },
        {
        id: "65",
        type: "TYPE_HIST",
        lines: [ 2355 ],
        text: "Дьабака",
        translate: "дьахтар бэргэһэтэ (женская шапка)"
        },
        {
        id: "66",
        type: "TYPE_HIST",
        lines: [ 3000 ],
        text: "Дьаҕа",
        translate: "саха музыкальнай инструмена (музыкальный инструмент якутов)"
        },
        {
        id: "67",
        type: "TYPE_HIST",
        lines: [ 1948 ],
        text: "Дьиэл",
        translate: "тирии халҕан (дверь, обшитая кожей)"
        },
        {
        id: "68",
        type: "TYPE_HIST",
        lines: [ 6414 ],
        text: "Дэлбиргэ",
        translate: "ыһыах кэмигэр ымыйалары уонна хомуостары баайан ыйыырга аналлаах маҥан сылгы сиэлиттэн оҥоһуллубут быа (веревка из белой конской гривы, употребляемая для перевязывания чаш и ковшей во время ысыаха)"
        },
        {
        id: "69",
        type: "TYPE_HIST",
        lines: [ 463 ],
        text: "Ийэ ууһа",
        translate: "аҕа ууһун сороҕо: биир удьуор аймахтыы дьон (материнский род)"
        },
        {
        id: "70",
        type: "TYPE_HIST",
        lines: [ 271 ],
        text: "Иҥсэ төрдө",
        translate: "олус сииргэ-аһыырга баҕардар куһаҕан тыын (злой дух, способствующий чрезмерной жадности, обжорству)"
        },
        {
        id: "71",
        type: "TYPE_HIST",
        lines: [ 2309, 4454 ],
        text: "Иҥэрчэ",
        translate: "ох сааны эрийбит иҥиир (сухильная обмотка лука и стрелы)"
        },
        {
        id: "72",
        type: "TYPE_HIST",
        lines: [ 756 ],
        text: "Иҥэрэ = иҥэрчэ",
        translate: "чаачар кирсэ охсор сирин эбэтэр икки уһугун тостубатын диэн иҥиир сабынан эрэдэһиннээн баайыы (сухожильная обмотка лука и стрелы)"
        },
        {
        id: "73",
        type: "TYPE_HIST",
        lines: [ 758, 2313, 4458 ],
        text: "Кирис",
        translate: "чаачары тардар хатыллыбыт тирии быа (тетива)"
        },
        {
        id: "74",
        type: "TYPE_HIST",
        lines: [ 906 ],
        text: "Көҕүөр",
        translate: "кымыһы көөнньөрөргө аналлаах сылгы тириититтэн оҥоһуллубут иһит (сосуд из конской кожи, в которой готовят кумыс)"
        },
        {
        id: "75",
        type: "TYPE_HIST",
        lines: [ 3788 ],
        text: "Көйүү кымыс",
        translate: "өр көөнньөрүллүбүт уоҕурбут хатан кымыс (подвергнутый длительному бражению, крепкий, перебродивший кумыс)"
        },
        {
        id: "76",
        type: "TYPE_HIST",
        lines: [ 2290 ],
        text: "Көнньүөс торҕо",
        translate: "күөх солко (китайский шелк зеленого цвета)"
        },
        {
        id: "77",
        type: "TYPE_HIST",
        lines: [ 176 ],
        text: "Көс",
        translate: "10 километрга тэҥнэһэр сахалыы уста кээмэйэ (якутская мера длины, равная в среднем 10 километров)"
        },
        {
        id: "78",
        type: "TYPE_HIST",
        lines: [ 5732 ],
        text: "Кулуба",
        translate: "Өрөбөлүүссүйэ иннинэ Саха сиригэр улуус быыбардам-мыт баһылыга (до революции в Якутии улусный голова)"
        },
        {
        id: "79",
        type: "TYPE_HIST",
        lines: [ 765 ],
        text: "Кулун кымыһа",
        translate: "ыам ыйын бүтүүтүгэр эбэтэр бэс ыйын саҥатыгар оҥоһуллар, кыра ыһыахха иһиллэр саамай эрдэтээҕи кымыс (самый ранний кумыс, распиваемый на малом Ысыахе в конце мая или в начале июня)"
        },
        {
        id: "80",
        type: "TYPE_HIST",
        lines: [ 2489 ],
        text: "Куойа",
        translate: "куйуур иэҕэн оҥоһуллубут мас иитэ (ободок рыболовного сака)"
        },
        {
        id: "81",
        type: "TYPE_HIST",
        lines: [ 6576 ],
        text: "Куомньалык=куонньалык",
        translate: "ох саа хаата, саадах (налучник, чехол для лука)"
        },
        {
        id: "82",
        type: "TYPE_HIST",
        lines: [ 1655  ],
        text: "Кытах",
        translate: "суунар таас саҕа мас иһит, улахан кытыйа (большая деревянная чаша)"
        },
        {
        id: "83",
        type: "TYPE_HIST",
        lines: [ 643 ],
        text: "Кытыйа",
        translate: "миискэ курдук дьоҕус мас иһит (деревянная долбленная чаша средней величины)"
        },
        {
        id: "84",
        type: "TYPE_HIST",
        lines: [ 2197  ],
        text: "Кычым",
        translate: "ыҥыыр икки өттүнэн ат ойоҕоһун саба түһэр тирии кэлим лоскуйа (тебенок, тебеньки седельные)"
        },
        {
        id: "85",
        type: "TYPE_HIST",
        lines: [ 5558 ],
        text: "Кыын быата",
        translate: "биилээх, уһуктаах сэп тимир өттө угуллар хаата (ножны)"
        },
        {
        id: "86",
        type: "TYPE_HIST",
        lines: [ 1104 ],
        text: "Кэлии",
        translate: "бурдук куолаһын, табах отун уо.д.а. соҕоҕунан үлтү сынньарга аналлаах хаһан оҥоһуллубут дириҥ истээх мас иһит (деревянная ступа из обрубка бревна)"
        },
        {
        id: "87",
        type: "TYPE_HIST",
        lines: [ 1515 ],
        text: "Кэһэх",
        translate: "ох хаата; хаа (колчан: вместилище чего-л.)"
        },
        {
        id: "88",
        type: "TYPE_HIST",
        lines: [ 2909 ],
        text: "Кэриэн айах",
        translate: "кэритэн кымыс иһэр иһит (круговая чаша для кумысопития)"
        },
        {
        id: "89",
        type: "TYPE_HIST",
        lines: [ 620, 4024 ],
        text: "Кэтэҕэриин",
        translate: "саха балаҕаныгар киирэр аан уонна оһох утары өттө (передняя сторона или часть якутской юрты напротив входа)"
        },
        {
        id: "90",
        type: "TYPE_HIST",
        lines: [ 1309 ],
        text: "Лааҕыра",
        translate: "куйуур куойатын туорайа (поперечина на ободке рыболовного сака, в ко¬торую упирается конец рукоятки)"
        },
        {
        id: "91",
        type: "TYPE_HIST",
        lines: [ 782 ],
        text: "Маалтааныка оноҕос = маалтаар оноҕос",
        translate: "мүлтүгүр төбөлөөх оноҕос (стрела с тупым наконечником, не повреждающая шкуры)"
        },
        {
        id: "92",
        type: "TYPE_HIST",
        lines: [ 2714 ],
        text: "Майдаан",
        translate: "муҥха балыгын мунньар миэстэ (место, где вливают добытую неводом рыбу)"
        },
        {
        id: "93",
        type: "TYPE_HIST",
        lines: [ 2489 ],
        text: "Маҥкы",
        translate: "куйуур ураҕаһа, эргитэр маһа (рукоятка рыболовного сака)"
        },
        {
        id: "94",
        type: "TYPE_HIST",
        lines: [ 2910, 2059 ],
        text: "Матаарчах",
        translate: "үүт аска аналлаах маһы хаһан оҥоһуллубут иһит (деревянный сосуд в виде усеченного конуса для хранения молочных продуктов)"
        },
        {
        id: "95",
        type: "TYPE_HIST",
        lines: [ 6521 ],
        text: "Мохсуо",
        translate: "анал бэрээдэгинэн ууруллубут кэрчик мастары таба быраҕаттаан, сурааһын таһыгар таһаарар спортивнай оонньуу (городки)"
        },
        {
        id: "96",
        type: "TYPE_HIST",
        lines: [ 274 ],
        text: "Обот иччитэ",
        translate: "иҥсэ иччитэ (дух жадности)"
        },
        {
        id: "97",
        type: "TYPE_HIST",
        lines: [ 4464, 4555 ],
        text: "Оноҕос",
        translate: "ох (стрела)"
        },
        {
        id: "98",
        type: "TYPE_HIST",
        lines: [ 6512 ],
        text: "Осхор",
        translate: "атырдьах курдук төбөлөөх оноҕос (стрела с вилообразным наконечником)"
        },
        {
        id: "99",
        type: "TYPE_HIST",
        lines: [ 3780, 3787, 770 ],
        text: "Саамал кымыс",
        translate: "саамыламмыт, көөнньүбүтүн кэннэ атын улахан иһиккэ мунньан, сөрүүҥҥэ туруоран, астытан иһэргэ бэлэмнэммит кымыс (уже дошедший до кондиции, постепенно сливаемый в большой сосуд для смешивания и охлаждения, лучшего качества кумыс)"
        },
        {
        id: "100",
        type: "TYPE_HIST",
        lines: [ 268 ],
        text: "Саа-саадах",
        translate: "былыргы саха ытар тэрилэ: ох саата, саатын хаата, ытар охторо, охторун хаата (старинный якутский лук со всеми принадлежностями: чехлом, колчаном со стрелами)"
        },
        {
        id: "101",
        type: "TYPE_HIST",
        lines: [ 2354 ],
        text: "Саҕаһа",
        translate: "оһох уотун уматарга туттуллар тымтык (лучина для разведения огня)"
        },
        {
        id: "102",
        type: "TYPE_HIST",
        lines: [ 2327 ],
        text: "Сандаала көмүс оноҕос",
        translate: "тимирдэрдээх оноҕос (стрела с нашитыми железными пластинками)"
        },
        {
        id: "103",
        type: "TYPE_HIST",
        lines: [ 714 ],
        text: "Саҥыйах = саҕынньах",
        translate: "тымныыга истээх сон таһынан кэтиллэр түүлээх киэҥ, ичигэс сон (дорожная меховая доха или шуба мехом наружу). "
        },
        {
        id: "104",
        type: "TYPE_HIST",
        lines: [ 4483 ],
        text: "Саһаан",
        translate: "урукку уста кээмэйэ, 2,134 миэтэрэҕэ тэҥ (старая русская мера длины, равная 2,134 м., сажень)"
        },
        {
        id: "105",
        type: "TYPE_HIST",
        lines: [ 5, 2907 ],
        text: "Сири иһит",
        translate: "тирииттэн тигиллибит үүт аһылыкка аналлаах иһит (сосуд из выделанной кожи)"
        },
        {
        id: "106",
        type: "TYPE_HIST",
        lines: [ 30 ],
        text: "Ситии",
        translate: "сылгы сиэлиттэн хатыллыбыт синньигэс быа (тонкая витая из конского волоса волосяная верёвка). "
        },
        {
        id: "107",
        type: "TYPE_HIST",
        lines: [ 4302 ],
        text: "Сулуу",
        translate: "урут кэргэн ылар киһи кыыс дьонугар сүөһүнэн биэрэр төлөбүрэ (калым в виде скота)"
        },
        {
        id: "108",
        type: "TYPE_HIST",
        lines: [ 626 ],
        text: "Суол аана",
        translate: "дьиэ иһинэн аан атта, аан аттын чэрчитэ; аан модьоҕото (место у порога в доме). "
        },
        {
        id: "109",
        type: "TYPE_HIST",
        lines: [ 2407 ],
        text: "Сүллүгэс",
        translate: "охсуһарга аналлаах баалкы (палка, используемая в сражении)"
        },
        {
        id: "110",
        type: "TYPE_HIST",
        lines: [ 650 ],
        text: "Сэбиргэл = сэбэргэнэ",
        translate: "саха балаҕаныгар икки кытыы өһүө бастарын холбуу туора ууруллар хаптаҕай бэрэбинэ (в якутской юрте: потолочное плоское бревно, кладущееся поперек на крайние матицы)"
        },
        {
        id: "111",
        type: "TYPE_HIST",
        lines: [ 470 ],
        text: "Сэмэ-суҥха",
        translate: "сыыһа быһыыланыыны буруйга, эппиэккэ тардыы, хомуруйуу (порицание, выговор, осуждение)"
        },
        {
        id: "112",
        type: "TYPE_HIST",
        lines: [ 469 ],
        text: "Сэт-сэлээн",
        translate: "сахаларга былыргы өйдөбүлүнэн, туох эмэ айыыны, улахан алҕаһы, куһаҕаны оҥордоххо, мүччүрүйбэт, төлөрүйбэт иэстэбил (расплата за неблаговидные деяния, возмездие, кара)"
        },
        {
        id: "113",
        type: "TYPE_HIST",
        lines: [ 790 ],
        text: "Тимир тиҥсирики оноҕос",
        translate: "чопчу сыалга түһэр тимир оноҕос (железная стрела, хорошо попадающая в цель)"
        },
        {
        id: "114",
        type: "TYPE_HIST",
        lines: [ 4129 ],
        text: "Томторҕо",
        translate: "сэргэ ойуута (утолщение между кольцеобразными зарубками коновязи)"
        },
        {
        id: "115",
        type: "TYPE_HIST",
        lines: [ 1596  ],
        text: "Тордуйа",
        translate: "туостан оҥоһуллубут иһит (берестяной сосуд)"
        },
        {
        id: "116",
        type: "TYPE_HIST",
        lines: [ 938 ],
        text: "Туут хайыһар",
        translate: "таба илин тыһынан бүрүллэр кэтит хайыһар (старинные большие лыжи, подбитые шкурой с передних лап оленя)"
        },
        {
        id: "117",
        type: "TYPE_HIST",
        lines: [ 2530 ],
        text: "Түнэ",
        translate: "түүтэ суох таҥастаммыт таба, тайах тириитэ (замша, ровдуга)"
        },
        {
        id: "118",
        type: "TYPE_HIST",
        lines: [ 5804 ],
        text: "Түөрэх",
        translate: "таҥхалыырга, билгэлииргэ туттуллар тээбирин: үөһэ күөрэччи быраҕан, тиэрэ дуу, умса дуу түһэринэн туох эмэ табыллыан эбэтэр табыллыа суоҕун эрдэттэн билэллэр (хол., хамыйах, ойуун былаайаҕа) (атрибут для гадания  (напр.,  большая  ложка  или  колотушка  от  бубна):  подбрасывая  его вверх, получают ответ – если предмет падает открытой стороной вверх, то желаемое сбудется, в противном случае – наоборот)"
        },
        {
        id: "119",
        type: "TYPE_HIST",
        lines: [ 6513 ],
        text: "Тыҥкырай",
        translate: "оноҕос көрүҥэ (определенный вид стрелы)"
        },
        {
        id: "120",
        type: "TYPE_HIST",
        lines: [ 3330 ],
        text: "Удьаа",
        translate: "кымыс баһар уһун уктаах дириҥ, улахан мас хамыйах (хомуостан кыра, хамыйахтан улахан) (большой деревянный ковш с длинной рукояткой для разливания кумыса, средний по величине между хомуос и хамыйах)"
        },
        {
        id: "121",
        type: "TYPE_HIST",
        lines: [ 5916 ],
        text: "Уорук",
        translate: "улахан,  киэҥ-куоҥ, үчүгэй тэриллээх олорор дьиэ (большой,  просторный,  хорошо  обставленный дом (жильё, жилище)"
        },
        {
        id: "122",
        type: "TYPE_HIST",
        lines: [ 1460 ],
        text: "Урааҥхай",
        translate: "сахалар бэйэлэрин ааттанар иккис ааттара (самоназвание якутов)"
        },
        {
        id: "123",
        type: "TYPE_HIST",
        lines: [ 628 ],
        text: "Үгэх",
        translate: "балаҕаҥҥа ол бу малы уурар кыра сир (Чуланчик, клодовка). "
        },
        {
        id: "124",
        type: "TYPE_HIST",
        lines: [ 267 ],
        text: "Үҥүү",
        translate: "уһун мас уктаах, икки өттүттэн биилээх кыргыһыыга туттуллар тимир сэрии сэбэ (копье, пика)"
        },
        {
        id: "125",
        type: "TYPE_HIST",
        lines: [ 5928, 6078 ],
        text: "Үөлэс",
        translate: "саха көмүлүөк оһоҕун буруо, төлөн тахсар турбата (дымовая труба камелька – якутской печи)"
        },
        {
        id: "126",
        type: "TYPE_HIST",
        lines: [ 440 ],
        text: "Үөлэс",
        translate: "саха көмүлүөк оһоһун буруо, төлөн тахсар турбата (дымовая труба комелька – якутской печи)"
        },
        {
        id: "127",
        type: "TYPE_HIST",
        lines: [ 4357 ],
        text: "Үөһээ курдуута",
        translate: "аан ийэ дойду ураһа быһыытыгар ураһа үөһээҥҥи хайаҕаһын бүүрүгэ, чампарыга, ураһа ураҕастарын үөһээ уһуктарын холбуу туттарыыта (верхняя опаяска деревянного остова якутской берестяной юрты)"
        },
        {
        id: "128",
        type: "TYPE_HIST",
        lines: [ 4534, 6079 ],
        text: "Үөрбэ",
        translate: "үҥүү көрүҥэ (хас да кырыы-лаах буолар) (род копья: с удлинённо-узким наконечником, который имеет несколько граней)"
        },
        {
        id: "129",
        type: "TYPE_HIST",
        lines: [ 266 ],
        text: "Үөрбэ долоҕодоһун",
        translate: "боотур кыргыһыыга туттар уһун, улахан быһаҕа (богатырское боевое оружие: большой длинный нож)"
        },
        {
        id: "130",
        type: "TYPE_HIST",
        lines: [ 2382 ],
        text: "Үөт түрэх",
        translate: "уоту булкуйар мас (кочерга)"
        },
        {
        id: "131",
        type: "TYPE_HIST",
        lines: [ 403 ],
        text: "Үрүҥ илгэ",
        translate: "былыргы саха өйдөбүлүнэн: күүс-уох киллэрэр, уйгу-быйаҥ төрдө булдар таҥара биэрэр аптаах сөлөгөйө (дар богов, дающее силу и богатство, божественная благодать, божественный сок)"
        },
        {
        id: "132",
        type: "TYPE_HIST",
        lines: [ 5520 ],
        text: "Үүн",
        translate: " ат баһыгар кэтэрдиллэр  уостуганнаах,  тэһииннээх,  үксүгэр куртан  оҥоһуллубут ат тэрилин  көрүҥэ (часть конской сбруи – ремни с удилами и поводьями, надеваемые на голову лошади, узда)"
        },
        {
        id: "133",
        type: "TYPE_HIST",
        lines: [ 642 ],
        text: "Хамыйах",
        translate: "хатыҥтан оҥоһуллубут аһы баһар тэрил (деревянный черпак, половник, деревянная поварешка)"
        },
        {
        id: "134",
        type: "TYPE_HIST",
        lines: [ 2682, 3770 ],
        text: "Хаппар",
        translate: "курга иилинэр кыра суумка (сумка, которую носят сбоку не ремне)"
        },
        {
        id: "135",
        type: "TYPE_HIST",
        lines: [ 2335, 1665 ],
        text: "Харыс",
        translate: "былыргы уста кээмэйэ: ууннары тутуллубут эрбэх төбөтүн уонна ортоку тарбах төбөтүн икки ардын саҕа уста (мера длины: большая пядь, равная расстоянию между концами расстянутых большого и среднего пальцев)"
        },
        {
        id: "136",
        type: "TYPE_HIST",
        lines: [ 1478, 1622 ],
        text: "Хатат",
        translate: "чокууру охсон, саҕан уот ыларга уонна биилээҕи сытыылыырга туттуллар хатарыылаах тимир (огниво)"
        },
        {
        id: "137",
        type: "TYPE_HIST",
        lines: [ 6183 ],
        text: "Холумтан",
        translate: "саха оһоҕун иннигэр уот отторго, ас буһарарга анаан буорунан симэн оҥоһуллубут үрдэтии (место для разведения огня, очаг, шесток (у камелька, печи))"
        },
        {
        id: "138",
        type: "TYPE_HIST",
        lines: [ 575 ],
        text: "Чаампы",
        translate: "балаҕан аанын үрдүнэн баар үтэн тахсар тутуу (нависающий выступ, козырек перед дверью в юрту-балаган)"
        },
        {
        id: "139",
        type: "TYPE_HIST",
        lines: [ 1299 ],
        text: "Чаан олгуй",
        translate: "күөстэнэр улахан иһит (большой сосуд для варки, котел)"
        },
        {
        id: "140",
        type: "TYPE_HIST",
        lines: [ 764, 3180, 2318 ],
        text: "Чаачар",
        translate: "ох саа (лук)"
        },
        {
        id: "141",
        type: "TYPE_HIST",
        lines: [ 423 ],
        text: "Чиэппэр",
        translate: "биир харыска тэҥнээх уста кээмэйэ (Мера длины, равная растоянию между кончиками большого и среднего пальцев широко раздвинутой кисти, четверть)"
        },
        {
        id: "142",
        type: "TYPE_HIST",
        lines: [ 309, 2770, 4918 ],
        text: "Чороон ымыйа",
        translate: "кэритэн иһэргэ аналлаах чороон (старинная круговая чаша для кумысопития)"
        },
        {
        id: "143",
        type: "TYPE_HIST",
        lines: [ 951 ],
        text: "Чыҥырҕастаах сыттык",
        translate: "кырыыларыгар хатан тыаһы таһаарар үрүҥ көмүстэрдээх сыттык (подушка с металлическими погремушками из серебряных пластинок по краям)"
        },
        {
        id: "144",
        type: "TYPE_HIST",
        lines: [ 4918 ],
        text: "Ымыйа",
        translate: "убаҕас аска туттуллар чабычахтыҥы быһыылаах мас иһит (большая деревянная чаша, большая посуда для жидкой пищи)"
        },
        {
        id: "145",
        type: "TYPE_HIST",
        lines: [ ],
        text: "Элбэрээк",
        translate: "сааны ытар эбэтэр айаны эһэр тордуох (крючок для спуска из лука или самострела)"
        },
        {
        id: "146",
        type: "TYPE_HIST",
        lines: [ 1030 ],
        text: "Этирик",
        translate: "тириини ыраастыырга, кыһыйарга аналлаах токур быһыылаах тимир сэп (железный дугообразный скобель для обработки кожи)"
        },            
    /* ДЬҮҺҮННҮҮР ТЫЛЛАР (ОБРАЗНАЯ ЛЕКСИКА) */
    {
        id: "147",
        type: "TYPE_OBR",
        lines: [ 5356 ],
        text: "Аанай",
        translate: "улаханнык абарыыны, кыйаханыыны көрдөрөр (междометие, выражающее сильную досаду, смешанную с раздражением, возмущением)"
        },
        {
        id: "148",
        type: "TYPE_OBR",
        lines: [ 1453 ],
        text: "Абына-табына",
        translate: "онон-манан, сэдэхтик (редко, негусто)"
        },
        {
        id: "149",
        type: "TYPE_OBR",
        lines: [ 462 ],
        text: "Айаҕымсах",
        translate: "иҥсэлээх, олус аһас диэн суолтаҕа (жадный, обжора)"
        },
        {
        id: "150",
        type: "TYPE_OBR",
        lines: [ 3916 ],
        text: "Айбалдьый",
        translate: "киэҥник, хотоойутук хамнанан тугу эрэ оҥор, үлэлээ (делать что-либо широкими, уверенными движениями)"
        },
        {
        id: "151",
        type: "TYPE_OBR",
        lines: [ 34, 6353 ],
        text: "Айгыр силик",
        translate: "сиппит хоппут, муҥутаабыт, күөҕүнэн симэммит (покрытая густой зеленью, разукрашенная роскошным зеленым ковром)"
        },
        {
        id: "152",
        type: "TYPE_OBR",
        lines: [ 108 ],
        text: "Ала-бааччы",
        translate: "харахха быраҕыллар, көстөн турар (очевидно, в самом деле, действительно)"
        },
        {
        id: "153",
        type: "TYPE_OBR",
        lines: [ 132 ],
        text: "Алла турар",
        translate: "өлгөмнүк, дэлэйдик өрө дэбэлийэ турар, бараммакка кутулла турар (появляться, как бы извергаться в изобилии, быть неиссекаемым и обильным)"
        },
        {
        id: "154",
        type: "TYPE_OBR",
        lines: [ 34 ],
        text: "Алы-намык",
        translate: "сымнаҕас майгылаах, амарах диэн суолтаҕа (в значении с мягким характером, милостливый)"
        },
        {
        id: "155",
        type: "TYPE_OBR",
        lines: [ 2365 ],
        text: "Аҥаарый",
        translate: "утуйа сылдьар курдук бытаар (быть медлительным, как только поснувшийся ото сна)"
        },
        {
        id: "156",
        type: "TYPE_OBR",
        lines: [ 4141 ],
        text: "Аппалдьыт",
        translate: "бэрт кыратык ас, сэгэт (чуть приоткрой)"
        },
        {
        id: "157",
        type: "TYPE_OBR",
        lines: [ 2039  ],
        text: "Арбахдьый = арбахачый",
        translate: "буралла сылдьар баттаххын арбатан сүүр (бежать, бросаясь в глаза своими растрепанными, взлохмаченными волосами)"
        },
        {
        id: "158",
        type: "TYPE_OBR",
        lines: [ 47 ],
        text: "Арылхай",
        translate: "киэҥ, ыраас, сырдык (харах туһунан) (большие, ясные светлые (о глазах)"
        },
        {
        id: "159",
        type: "TYPE_OBR",
        lines: [ 369 ],
        text: "Арылы чэлгиэ алаастар",
        translate: "сырдык, ыраас, силигилии, муҥутуу көҕөрбүт алаастар (светлые, ясные, покрытые зеленью алаасы)"
        },
        {
        id: "160",
        type: "TYPE_OBR",
        lines: [ 33 ],
        text: "Атааннаах-мөҥүөннээх",
        translate: "аймалҕаннаах, түрбүөннээх диэн суолтаҕа (в значении беспокойный, тревожный)"
        },
        {
        id: "161",
        type: "TYPE_OBR",
        lines: [ 377 ],
        text: "Атырдьах туйахтаах",
        translate: "ынах сүөһүнү бэлиэтиир кубулуйбат эпитет (постоянный эпитет для обозначения крупного рогатого скота)"
        },
        {
        id: "162",
        type: "TYPE_OBR",
        lines: [ 370, 810, 2039, 3978 ],
        text: "Ахталый",
        translate: "атахтаргын аччаччы быраҕан дьоһумсуйбуттуу аа-дьуо ыараханнык хаамп, сыҕарый (шагать тяжело, медленно на широко расставленных ногах, с претензией на собственную важность и внушительность)"
        },
        {
        id: "163",
        type: "TYPE_OBR",
        lines: [ 1608 ],
        text: "Аччай = ахчай",
        translate: "атахтаргын киэҥник үктээ уонна бокуй (широко раставлять и сгибать ноги)"
        },
        {
        id: "164",
        type: "TYPE_OBR",
        lines: [ 556 ],
        text: "Баабыр",
        translate: "модун, сүҥкэҥ диэн суолтаҕа (в значении могучий, огромный)"
        },
        {
        id: "165",
        type: "TYPE_OBR",
        lines: [ 661 ],
        text: "Бабаарыма = аарыма",
        translate: "олус улахан (очень большой)"
        },
        {
        id: "166",
        type: "TYPE_OBR",
        lines: [ 5720 ],
        text: "Баллырҕаа",
        translate: " айаҕын иһигэр тылыҥ бап-пакка мэһэйдии сылдьарын курдук олуттаҕастык саҥар (говорить невнятно (как будто язык во рту не помещается))"
        },
        {
        id: "167",
        type: "TYPE_OBR",
        lines: [ 5510 ],
        text: "Бардьыгыначчы",
        translate: " хабах буола үллэн таҕыс (вздуваться от пузырей, пузыриться)"
        },
        {
        id: "168",
        type: "TYPE_OBR",
        lines: [ 5832 ],
        text: "Барыдас",
        translate: "биир күдьүстүк, улаханнык харылыы тыаһыыр (производящий беспрерывный шум, рокот )"
        },
        {
        id: "169",
        type: "TYPE_OBR",
        lines: [ 2887 ],
        text: "Барыкыс гын",
        translate: "эмискэ баар буол (появится внезапно)"
        },
        {
        id: "170",
        type: "TYPE_OBR",
        lines: [ 426 ],
        text: "Барыҥнаа",
        translate: "борук-сорукка, хараҥаҕа омооно эрэ буолан, чуолкайа суохтук көһүн (двигаться, едва виднеясь в темноте)"
        },
        {
        id: "171",
        type: "TYPE_OBR",
        lines: [ 954, 3796 ],
        text: "Баччыгынаа",
        translate: "муннугун улаханнык хаһыҥыраччы тыаһат (сильно, шумно сопеть; издавать свистящие звуки, храп)"
        },
        {
        id: "172",
        type: "TYPE_OBR",
        lines: [ 557 ],
        text: "Бачыгырай",
        translate: "кылгас-кылгастык хабырыта барар, тыһыргыыр тыаһы таһаарар (издавать короткий трескучий звук, производить короткий треск)"
        },
        {
        id: "173",
        type: "TYPE_OBR",
        lines: [ 1608 ],
        text: "Битигирэй",
        translate: "биир тэҥ чаастатык тоҥсуйан, лигийэн эрэ курдук тыаһаа (издавать интенсивный дробный звук)"
        },
        {
        id: "174",
        type: "TYPE_OBR",
        lines: [ 671 ],
        text: "Биэкэй",
        translate: "биилгинэн синньээн көһүн (быть очень тонким в талии, тонкостанным)"
        },
        {
        id: "175",
        type: "TYPE_OBR",
        lines: [ 5798 ],
        text: "Боҕуй",
        translate: "төҥкөҥнөө,сүгүрүй (нагибаться, кланяться)"
        },
        {
        id: "176",
        type: "TYPE_OBR",
        lines: [ 4550 ],
        text: "Быакай",
        translate: "өттүктээх,сарыннаах эрээри биилгинэн лаппа син-ньээн көһүн (иметь тонкую талию)"
        },
        {
        id: "177",
        type: "TYPE_OBR",
        lines: [ 1432 ],
        text: "Былластыгас",
        translate: "улаханнык тэллэйэ сылдьар халыҥ (толстый и отвислый)"
        },
        {
        id: "178",
        type: "TYPE_OBR",
        lines: [ 58 ],
        text: "Бэрдьигэс мас",
        translate: "саҥа үүнэн эрэр мас (низкорослое деревце, лес)"
        },
        {
        id: "179",
        type: "TYPE_OBR",
        lines: [4727 ],
        text: "Даллас гынан биэр",
        translate: "ыраахтан улаатан багдайан көһүн (казаться издали огромным)"
        },
        {
        id: "180",
        type: "TYPE_OBR",
        lines: [ 672 ],
        text: "Дарай",
        translate: "кэтит, улахан сарыннаах буол, оннук буолан көһүн (иметь широкие плечи, быть, казаться широкоплечим)"
        },
        {
        id: "181",
        type: "TYPE_OBR",
        lines: [ 4349 ],
        text: "Долгулдьуй",
        translate: "аргыый өрүтэ түллүтэлээн долгуннуран хаамсыы (слегка волноваться, рябить)"
        },
        {
        id: "182",
        type: "TYPE_OBR",
        lines: [ 4798 ],
        text: "Дук гын аас",
        translate: "кими-тугу эмэ илиигинэн эбэтэр тугунан эмэ таарый (прикоснуться к чему-л. рукой или дотронуться до кого-чего-л. каким-л. предметом, ткнуть)"
        },
        {
        id: "183",
        type: "TYPE_OBR",
        lines: [ 81 ],
        text: "Дуодаллый",
        translate: "ордук уһаан, үрдээн көһүн (быть, казаться чересчур вытянутым)"
        },
        {
        id: "184",
        type: "TYPE_OBR",
        lines: [ 168 ],
        text: "Дуолан",
        translate: "муҥутуур улахан, сүүнэ улахан (громадный, огромный)"
        },
        {
        id: "185",
        type: "TYPE_OBR",
        lines: [ 3130  ],
        text: "Дэбилий",
        translate: "өрө үтэн, үллэн таҕыс, бурулуй (бурлить, бурно кипеть, клокотать, переполняться)"
        },
        {
        id: "186",
        type: "TYPE_OBR",
        lines: [ 1215 ],
        text: "Дэллэкэччит = тэлэкэчит",
        translate: "өйдөнөр түгэн биэрбэккэ күүс өттүнэн тардыалаан, соһуолаан илт (не давая опомниться, с силой тянуть за собой)"
        },
        {
        id: "187",
        type: "TYPE_OBR",
        lines: [ 736 ],
        text: "Дэлэбиир = дэлбээр",
        translate: "салгыҥҥа уйдаран үөһээнэн тэлээрэ көт (медленно, плавно парить в воздухе)"
        },
        {
        id: "188",
        type: "TYPE_OBR",
        lines: [ 1484 ],
        text: "Дьалаҕай",
        translate: "көтүмэх, болҕомтото суох, ээл-дээл (небрежный, неаккуратный, халатный)"
        },
        {
        id: "189",
        type: "TYPE_OBR",
        lines: [ 5821 ],
        text: "Дьалкылдьый",
        translate: "долгуйан, түллэн  хамсаа,  чалымнаа  (волноваться, колыхаться, плескаться)"
        },
        {
        id: "190",
        type: "TYPE_OBR",
        lines: [ 5924 ],
        text: "Дьирибинээ",
        translate: "түргэн-түргэнник  тэлибирии-илибирии  хамсаа (трепетать, мелко дрожать, биться)"
        },
        {
        id: "191",
        type: "TYPE_OBR",
        lines: [ 82 ],
        text: "Дьоҥхоҕор",
        translate: "уһун синньигэс, үрдүк көнө (высокий, стройный, долговязый)"
        },
        {
        id: "192",
        type: "TYPE_OBR",
        lines: [ 1213 ],
        text: "Дьохсооттоо",
        translate: "кыыһыран, суоһурҕанан дьарыйыахтыы, кэһэтиэхтии тутун (вести себя агрессивно, будто готов сейчас же напасть)"
        },
        {
        id: "193",
        type: "TYPE_OBR",
        lines: [ 1223 ],
        text: "Дьөгдьөрүс гын",
        translate: "арҕаскын бөгдьөтөн, тиэтэллээхтик инниҥ диэки аллара түс (согнувшись, быстро податься вперед, свалиться)"
        },
        {
        id: "194",
        type: "TYPE_OBR",
        lines: [ 95  ],
        text: "Дьулаагыр маҕан",
        translate: "биир күрүс маҕан (совсем белый, белоснежный)"
        },
        {
        id: "195",
        type: "TYPE_OBR",
        lines: [ 4065 ],
        text: "Дьэс кыыс",
        translate: "кыһыл алтан өҥүнүү кытар (краснеть, алеть, багроветь, становиться цвета красной меди)"
        },
        {
        id: "196",
        type: "TYPE_OBR",
        lines: [ 32 ],
        text: "Иилээх-саҕалаах",
        translate: "Орто дойдуну хоһуйарга туттуллар кубулуйбат эпитет (эпитет, используемый при описании Срединной земли)"
        },
        {
        id: "197",
        type: "TYPE_OBR",
        lines: [ 587 ],
        text: "Иир-мэнэрий",
        translate: "кэмиттэн-кэмигэр тиһиктэнэн, ииригирэн кэл (биться в нервном припадке, бесноваться)"
        },
        {
        id: "198",
        type: "TYPE_OBR",
        lines: [ 373 ],
        text: "Илбирээ = илибирээ",
        translate: "чэпчэкитик, түргэн-түргэнник, төттөрү-таары охсуллан хамсаа (трепетать, подрагивать)"
        },
        {
        id: "199",
        type: "TYPE_OBR",
        lines: [ 941 ],
        text: "Илибирэччи",
        translate: "илибирии хамсыыр гына, эйэҥэлэтэн (так, чтобы дрожало, трепетало)"
        },
        {
        id: "200",
        type: "TYPE_OBR",
        lines: [ 3948 ],
        text: "Илигирэт",
        translate: "түргэн-түргэнник, тэтимнээхтик төттөрү-таара хамсат (вибрировать, мелко дрожать)"
        },
        {
        id: "201",
        type: "TYPE_OBR",
        lines: [ 796 ],
        text: "Илэ-бодо",
        translate: "кистэммэккэ, саспакка, аһаҕастык (не таясь, не скрываясь, открыто)"
        },
        {
        id: "202",
        type: "TYPE_OBR",
        lines: [ 1325 ],
        text: "Иэҕэлдьий",
        translate: "икки өттүгэр иҥнэҥнээн ыл (пошатываться)"
        },
        {
        id: "203",
        type: "TYPE_OBR",
        lines: [ 5687 ],
        text: "Килэрий",
        translate: "ньалҕархай килэгир ньуурданан  көһүн (блестеть, лосниться, иметь глянцевую поверхность)"
        },
        {
        id: "204",
        type: "TYPE_OBR",
        lines: [ 2453 ],
        text: "Кимсиин-имсиин",
        translate: "киһи кута-сүрэ тэһийбэт дойдута (чужая страна, в которой чувствуешь беспокойство)"
        },
        {
        id: "205",
        type: "TYPE_OBR",
        lines: [ 3985 ],
        text: "Көбүөх гына",
        translate: "биирдэ өндөх гына, хамсаан ыла (силиться приподняться, шевельнуться)"
        },
        {
        id: "206",
        type: "TYPE_OBR",
        lines: [ 5550 ],
        text: "Кулгуй",
        translate: "аһаабыт ас сорҕотун  айаххынан  төттөрү  таһаар (срыгивать обратно часть съеденного)"
        },
        {
        id: "207",
        type: "TYPE_OBR",
        lines: [ 1542 ],
        text: "Куһурҕаа",
        translate: "салгыны тыыран иһиирэр курдук тыастары таһаар (издавать свистящие звуки, рассекая воздух)"
        },
        {
        id: "208",
        type: "TYPE_OBR",
        lines: [ 579 ],
        text: "Кутур",
        translate: "ис-искиттэн долгуйан, эҥсэлитэн, улаханнык ыллаа (петь громко, исступленно)"
        },
        {
        id: "209",
        type: "TYPE_OBR",
        lines: [ 5912 ],
        text: "Күдээрий",
        translate: "салгыҥҥа өрө көтөн өрүкүйэн таҕыс (подниматься, клубиться)"
        },
        {
        id: "210",
        type: "TYPE_OBR",
        lines: [ 5684 ],
        text: "Күллүргээ",
        translate: " тохтоло суох күллүргэс тыаһы таһаар (производить  прерывистый  и  глухой  шум,  накатывая  и ударяясь о  берег,  плескаться)"
        },
        {
        id: "211",
        type: "TYPE_OBR",
        lines: [ 5464 ],
        text: "Күлүбүрэччи",
        translate: "тыастаахтык-уустаахтык, өрө саласпыттыы омуннаахтык (умай) (ярко, весело, гудящим пламенем  (гореть))"
        },
        {
        id: "212",
        type: "TYPE_OBR",
        lines: [ 449 ],
        text: "Күн улууһа",
        translate: "айыы аймахтара олорор сирдэрэ, Орто дойду (место где живут люди племени айыы, Срединный мир)"
        },
        {
        id: "213",
        type: "TYPE_OBR",
        lines: [ 5761 ],
        text: "Күөгэй",
        translate: " аа-дьуо нуоҕайа хамсаа (плавно,  мягко  клониться,  склоняться)"
        },
        {
        id: "214",
        type: "TYPE_OBR",
        lines: [ 3910 ],
        text: "Күөдэйбитинэн",
        translate: "сааһыламмакка мэнээк үрүт-үрдүгэр ыһыллан, биир сиргэ өрөһөлөнөн. (разбросанно, беспорядочной кучей)"
        },
        {
        id: "215",
        type: "TYPE_OBR",
        lines: [ 559 ],
        text: "Күөкэс = күөкэй",
        translate: "уһун синньигэс моонньугун өрө, күөрэччи тутун (изящно, грациозно держать вытянутую тонкую шею)"
        },
        {
        id: "216",
        type: "TYPE_OBR",
        lines: [ 4187 ],
        text: "Күөрэҥсэ",
        translate: "сотору-сотору өрүтэ күөрэйтэлиир, күөрэс гынар (равномерно, регулярно взлетающий вверх)"
        },
        {
        id: "217",
        type: "TYPE_OBR",
        lines: [ 169 ],
        text: "Күрдьүөттээ",
        translate: "харсаары эбэтэр кэйээри суоһурҕанан муостаргын тоһуй (принимать угрожающую позу, сердито коситься, выставляя рога)"
        },
        {
        id: "218",
        type: "TYPE_OBR",
        lines: [ 78 ],
        text: "Кыйдам маҕан",
        translate: "ыраас, мап-маҕан диэн суолтаҕа (в значении чистый, белоснежный)"
        },
        {
        id: "219",
        type: "TYPE_OBR",
        lines: [ 65 ],
        text: "Кылбаҕар",
        translate: "мап-маҕан, ып-ыраас (сияющий белезной, без единого пятнышка)"
        },
        {
        id: "220",
        type: "TYPE_OBR",
        lines: [ 1533  ],
        text: "Кылбай",
        translate: "сырдыктык, чаҕылыччы тык; арылыйан, сырдаан көһүн (светиться ярко; быть, казаться ярким, светлым)"
        },
        {
        id: "221",
        type: "TYPE_OBR",
        lines: [ 66 ],
        text: "Кынталлыбыт",
        translate: "төбөтүн чоноччу туттан, моонньутун уһатан, үрдээн чынайан көстөр (быть стройным, с высоко, горделиво поднятой головой)"
        },
        {
        id: "222",
        type: "TYPE_OBR",
        lines: [ 76 ],
        text: "Кытаахтаа",
        translate: "тугу эмэ кыраны тутан ыл (хватать, захватывать что-либо мелкое)"
        },
        {
        id: "223",
        type: "TYPE_OBR",
        lines: [ 396 ],
        text: "Кыыбырҕаа",
        translate: "аһыҥа, көтөр кынатын тыаһыгар маарынныыр тыаһы таһаар (издавать мягкий, стрекочущий звук, стрекотать)"
        },
        {
        id: "224",
        type: "TYPE_OBR",
        lines: [ 4729 ],
        text: "Кэҕис гынан биэр",
        translate: "кими-тугу эмэ илиигинэн эбэтэр тугунан эмэ таарый (прикоснуться к чему-л. рукой или дотронуться до кого-чего-л. каким-л. предметом, ткнуть)"
        },
        {
        id: "225",
        type: "TYPE_OBR",
        lines: [ 415 ],
        text: "Кэйбэлдьийбэт кэй бараан",
        translate: "барыларыттан эрэ чыҥха, саамай үчүгэй, хамсаабат дойду (самая лучша, выделяющаяся неподвижная страна)"
        },
        {
        id: "226",
        type: "TYPE_OBR",
        lines: [ 136 ],
        text: "Кэҥкэй",
        translate: "киэҥ, аппаҕар буолан көһүн (быть широко открытым, зиять бездной)"
        },
        {
        id: "227",
        type: "TYPE_OBR",
        lines: [ 136 ],
        text: "Кэриҥнэнэн",
        translate: "быһыыланан, киэптэнэн (иметь какую-либо форму)"
        },
        {
        id: "228",
        type: "TYPE_OBR",
        lines: [ 131 ],
        text: "Лагладьдьый",
        translate: "түргэнник хаамп (идти, двигаться быстро)"
        },
        {
        id: "229",
        type: "TYPE_OBR",
        lines: [ 638 ],
        text: "Лип-хаан",
        translate: "улахан, сүүнэ (громадный, огромного размера)"
        },
        {
        id: "230",
        type: "TYPE_OBR",
        lines: [ 1713  ],
        text: "Лис гын",
        translate: "үөһэттэн тугу эмэ кытаанахха түһэрэн тыаһат (производить глухой звук тяжелого, крепкого удара)"
        },
        {
        id: "231",
        type: "TYPE_OBR",
        lines: [ 3935 ],
        text: "Лиһигирэһии",
        translate: "улаханнык ньиргийэн субуллук тыаһаан (грохотать, громыхать)"
        },
        {
        id: "232",
        type: "TYPE_OBR",
        lines: [ 1612 ],
        text: "Маадьай",
        translate: "тобуктарын икки ардынан ордук арыттаах, токур буолан көһүн (стать кривоногим)"
        },
        {
        id: "233",
        type: "TYPE_OBR",
        lines: [ 395 ],
        text: "Маатырҕаа",
        translate: "маат-маат диэн саҥар (крякать)"
        },
        {
        id: "234",
        type: "TYPE_OBR",
        lines: [ 680 ],
        text: "Малаҕар",
        translate: "кэтит, этиргэн сирэйдээх (широколицый, с открытым лицом)"
        },
        {
        id: "235",
        type: "TYPE_OBR",
        lines: [ 389 ],
        text: "Марай",
        translate: "күүрэҥҥин түөскүн мөтөт, кэтит, киппэ түөстээх буолан көһүн (пыпячивать грудь при ходьбе, беге)"
        },
        {
        id: "236",
        type: "TYPE_OBR",
        lines: [ 5802 ],
        text: "Мөтөй",
        translate: " түөскүн иннин диэки мөтөччү тутун (выпячивать грудь)"
        },
        {
        id: "237",
        type: "TYPE_OBR",
        lines: [ 57 ],
        text: "Мэтэлдьий",
        translate: "түөскүн мөтөтөн хаамп (ходить, выпятив грудь)"
        },
        {
        id: "238",
        type: "TYPE_OBR",
        lines: [ 5490 ],
        text: "Намылыт",
        translate: "уһун  субурҕа  тугу  эмэ  үөһэттэн  аллара  түһэр, ыйаан  субурут (свесить,  опустить что-л.  вниз,  распустить)"
        },
        {
        id: "239",
        type: "TYPE_OBR",
        lines: [ 4152 ],
        text: "Нүрүйэн",
        translate: "төҥкөччү туттан (пригнувшись, склонившись)"
        },
        {
        id: "240",
        type: "TYPE_OBR",
        lines: [ 4124 ],
        text: "Нэлбэгэйдии",
        translate: "санныгар бүрүнэ, саба быраҕа (накинув на плечи)"
        },
        {
        id: "241",
        type: "TYPE_OBR",
        lines: [ 1502 ],
        text: "Нэлбэй",
        translate: "аллара өттүнэн кэтирээ, намылыйан түс (ниспадать, расширяясь книзу)"
        },
        {
        id: "242",
        type: "TYPE_OBR",
        lines: [ 715 ],
        text: "Нэллэгэйдии = нэлэгэйдэн",
        translate: "сонун тимэхтэрин сүөрэн, аһаҕас сырыт (широко распахивать шубу, доху)"
        },
        {
        id: "243",
        type: "TYPE_OBR",
        lines: [ 3895 ],
        text: "Нэмэлис гына түс ",
        translate: "үөһэттэн аллараа намылыйан түс (свешиваться, свисать, спадать)"
        },
        {
        id: "244",
        type: "TYPE_OBR",
        lines: [ 5611 ],
        text: "Ньалҕарыт",
        translate: "тарҕанар, халыйар гына илит (сделать так, что-бы что-л. расплылось, растеклось; растопить,  разморозить  что-л.)"
        },
        {
        id: "245",
        type: "TYPE_OBR",
        lines: [ 4537 ],
        text: "Ньиргийэ түс",
        translate: "улахан дорҕоонноохтук тыаһаа-ууһаа; улаханнык дуораһый (издавать громкие, ньир  раскастистые  звуки,  греметь)"
        },
        {
        id: "246",
        type: "TYPE_OBR",
        lines: [ 387 ],
        text: "Ньохчой",
        translate: "бөгдьөллөн, накыйан аччаан хаал (становиться сгорбленным, осевшим)"
        },
        {
        id: "247",
        type: "TYPE_OBR",
        lines: [ 387 ],
        text: "Ньөкөрүс = ньөкөй",
        translate: "үөһээ өттүгүн төҥкөччү тутун (пригнуться, согнуться, наклониться)"
        },
        {
        id: "248",
        type: "TYPE_OBR",
        lines: [ 551 ],
        text: "Оҕоруктаах",
        translate: "кубулҕаттаах, угаайылаах (хитрый, коварный)"
        },
        {
        id: "249",
        type: "TYPE_OBR",
        lines: [ 730, 1540  ],
        text: "Олодуй",
        translate: "ол-бу диэки хоноччу туттан көрбөхтөө, хайыспахтаа (оглядываться в стороны, держа голову высоко)"
        },
        {
        id: "250",
        type: "TYPE_OBR",
        lines: [ 43 ],
        text: "Олоор-молоор",
        translate: "ол бу диэки эргиччи көр (смотреть по сторонам туда-сюда)"
        },
        {
        id: "251",
        type: "TYPE_OBR",
        lines: [ 859 ],
        text: "Онньой",
        translate: "аллараа өттүгүнэн ханньаччы үктэн, тэпсилин (быть стоптанным набок)"
        },
        {
        id: "252",
        type: "TYPE_OBR",
        lines: [ 863 ],
        text: "Онолун",
        translate: "айаххын оҥоччу атан, сирэйиҥ уһаан, инниҥ диэки бөкчөччү түс (горбиться с растянутым лицом и с приоткрытым ртом)"
        },
        {
        id: "253",
        type: "TYPE_OBR",
        lines: [ 1439 ],
        text: "Оҥой",
        translate: "төгүрүктүҥү дьөлөҕөстөөх буол (зиять)"
        },
        {
        id: "254",
        type: "TYPE_OBR",
        lines: [ 793 ],
        text: "Оот-татай",
        translate: "соһуйууну, сөҕүүнү бэлиэтиир саҥа аллайыы (междометие, выражающее сильное удивление, изумление)"
        },
        {
        id: "255",
        type: "TYPE_OBR",
        lines: [ 5322 ],
        text: "Өкөр",
        translate: "иҥнэри  түс,  иҥнэй (накренившийся,  наклонившийся,  наклонно стоящий)"
        },
        {
        id: "256",
        type: "TYPE_OBR",
        lines: [ 4743 ],
        text: "Өкчөччү тутун",
        translate: "төҥкөйбүт, бөкчөйбүт курдук тутун (держаться сгорбившись, съёжившись)"
        },
        {
        id: "257",
        type: "TYPE_OBR",
        lines: [ 1228 ],
        text: "Өрөкүс гын =  өрүкүс гын",
        translate: "өрө бурҕайан таҕыс, чыпчылыйыах түгэҥҥэ өрө түллэн үтэн таҕыс (вздыматься, развеваться, моментально подняться)"
        },
        {
        id: "258",
        type: "TYPE_OBR",
        lines: [ 196 ],
        text: "Саатаа",
        translate: "аралдьыйар курдук тугу эмэ гын, тугунан эмэ санааҕын аралдьыт (равлекаться, забавляться чем-либо)"
        },
        {
        id: "259",
        type: "TYPE_OBR",
        lines: [ 262 ],
        text: "Саньылҕа = санньылҕа",
        translate: "санаарҕабыллаах, санаа түһүүлээх, курус; күүһэ-күүрээнэ суох, мунчаарыылаах, муҥкук (унылый, грустный, печальный, поникший)"
        },
        {
        id: "260",
        type: "TYPE_OBR",
        lines: [ 1740  ],
        text: "Сап гын",
        translate: "киһи тугу эмэ уобар тыаһыныы тыаһаа (произвести шум, похожий на шлепок губами)"
        },
        {
        id: "261",
        type: "TYPE_OBR",
        lines: [ 5780 ],
        text: "Сарбай",
        translate: " тугу эмэ тутаары,  харбаан  ылаары  илиигин  эбэтэр тыҥырахтаргын  саратан чугаһат (вытягивать руку или лапу с растопыренными когтями к кому-чему-л. с намерением схватить)"
        },
        {
        id: "262",
        type: "TYPE_OBR",
        lines: [ 363 ],
        text: "Сахсаччы",
        translate: "сахсайа сылдьар гына (так, чтобы взбилась пена)"
        },
        {
        id: "263",
        type: "TYPE_OBR",
        lines: [ 1482 ],
        text: "Солоҕой",
        translate: "сүөргү, солуута суох, сэлээр (несерьезный, ветреный)"
        },
        {
        id: "264",
        type: "TYPE_OBR",
        lines: [ 5321 ],
        text: "Сөрүөстүгэс",
        translate: "киһи тылыгар киириммэт үгэс-тээх,  өһөс,  хадаар (упрямый,  несговорчивый,  неподатливый,  неуступчивый)"
        },
        {
        id: "265",
        type: "TYPE_OBR",
        lines: [ 1341 ],
        text: "Суккуллун",
        translate: "барамматы сүөкүүр курдук өлгөмнүк кутулун, тоҕун, түс (литься нескончаемым потоком)"
        },
        {
        id: "266",
        type: "TYPE_OBR",
        lines: [ 173 ],
        text: "Суксурус",
        translate: "инники-кэнники буолан субуруһан туруҥ (распологаться друг за другом)"
        },
        {
        id: "267",
        type: "TYPE_OBR",
        lines: [ 1252 ],
        text: "Суодай",
        translate: "үрдүк, күлүктээх көрүҥнээх буол (быть крупным, иметь внушительный рост)"
        },
        {
        id: "268",
        type: "TYPE_OBR",
        lines: [ 1084 ],
        text: "Суодуй",
        translate: "чиҥээн, дьиппинийэн аллара түс (падать сверху, низвергаться)"
        },
        {
        id: "269",
        type: "TYPE_OBR",
        lines: [ 3777 ],
        text: "Суон сааллан",
        translate: "уойан саал сыалан (нагулять жир на загривке)"
        },
        {
        id: "270",
        type: "TYPE_OBR",
        lines: [ 5929 ],
        text: "Сурулаа",
        translate: "быстыбакка сытыытык биир кэм «сурр» гынан тыаһаа (производить непрерывный шум при быстром скольжении, стремительном  падении  с  высоты)"
        },
        {
        id: "271",
        type: "TYPE_OBR",
        lines: [ 987 ],
        text: "Сурулаччы",
        translate: "быстыбакка сытыытык биир кэм «сурр» гына тыаһаан (производя непрерывный свистящий, шуршащий шум"
        },
        {
        id: "272",
        type: "TYPE_OBR",
        lines: [ 427 ],
        text: "Сүөдэҥнээ",
        translate: "аа-дьуо икки өттүгэр иэҕэҥнээн, бытааннык хаамп (идти, двигаться медленно, неторопливо, слегка переваливаясь с боку на бок)"
        },
        {
        id: "273",
        type: "TYPE_OBR",
        lines: [ 986 ],
        text: "Сүргүччү",
        translate: "сүүһүн аннынан (көр) (исподлобья, о взгляде)"
        },
        {
        id: "274",
        type: "TYPE_OBR",
        lines: [ 1430 ],
        text: "Сылластыгас",
        translate: "олус халыҥ уонна тиэрэ сыҕаллан тахсыбыт (очень толстый, некрасиво вывернутый наружу, о губах и подбородке)"
        },
        {
        id: "275",
        type: "TYPE_OBR",
        lines: [ 4776 ],
        text: "Сылыбыраччы",
        translate: "иҥнигэһэ суохтук, биир тэҥ кудуххайдык уонна имигэстик (без запинки, быстро и проворно)"
        },
        {
        id: "276",
        type: "TYPE_OBR",
        lines: [6346 ],
        text: "Сыппай сиэллээх=сыспай сиэллээх",
        translate: "сылгы сүөһү, сылгы сыыйыллаҕас уһун сиэллээҕин хоһуйан этии (лошадь, табун лошадей, букв. животное с длинной, ниспадающей густой гривой)"
        },
        {
        id: "277",
        type: "TYPE_OBR",
        lines: [ 381 ],
        text: "Сыспай сиэллээх",
        translate: "сылгы сүөһүнү бэлиэтиир кубулуйбат эпитет (постоянный эпитет, обозначающий конный скот)"
        },
        {
        id: "278",
        type: "TYPE_OBR",
        lines: [ 1498 ],
        text: "Сэймэктээ",
        translate: "быһыта-хайыта, тырыта тыыт, үлтү кырбаа (терзать, разрывать на части)"
        },
        {
        id: "279",
        type: "TYPE_OBR",
        lines: [ 5725 ],
        text: "Һой-буйака",
        translate: "норуот ырыатыгар-хоһоонугар саҥарааччы туох эмэ кыһалҕатын, туохтан эмэ ыксаа-бытын биллэрэр тылын курдук туттуллар (в народных песнях употребляется как слово, выражающее сильное беспокойство говорящего о чем-л.)"
        },
        {
        id: "280",
        type: "TYPE_OBR",
        lines: [ ],
        text: "Таалыйа = таалай",
        translate: "булкааһа суох, биир күрүс, чаҕылхай (Очень яркий, насыщенный). 548"
        },
        {
        id: "281",
        type: "TYPE_OBR",
        lines: [ 3830 ],
        text: "Талахачыччы",
        translate: "харса суох мөҕүһүннэрэн (заставить беспорядочно двигаться, биться)"
        },
        {
        id: "282",
        type: "TYPE_OBR",
        lines: [ 942 ],
        text: "Талыбыраччы",
        translate: "тыастаахтык, түргэн-түргэнник күүскэ мөҕүһүннэрэн (встряхивая, издавая частые шумные хлопки)"
        },
        {
        id: "283",
        type: "TYPE_OBR",
        lines: [ 3986 ],
        text: "Тартах гын",
        translate: "кэҥээ, улаат (раздуваться, расширяться)"
        },
        {
        id: "284",
        type: "TYPE_OBR",
        lines: [ 3807 ],
        text: "Тигинэй",
        translate: "күүскэ, тэтимнээхтик умай (сильно, интенсивно горит)"
        },
        {
        id: "285",
        type: "TYPE_OBR",
        lines: [ 4029 ],
        text: "Тилигирэччи",
        translate: "биир тэҥ тэтимнээхтик, тилигирэс тыастаахтык (производя непрерывный дробный стук)"
        },
        {
        id: "286",
        type: "TYPE_OBR",
        lines: [ 5693 ],
        text: "Тиҥийээ-таҥыйаа = тигинээ-таҥынаа",
        translate: "ньиргиэрдээх, улахан тыаһы-ууһу таһаар. (производить гулкий стук, сильный  шум)"
        },
        {
        id: "287",
        type: "TYPE_OBR",
        lines: [ 5685 ],
        text: "Тиҥиргэс",
        translate: "биир  кэм бүтэҥитик  ньиргийэр  (гулко стучащий, гремящий)"
        },
        {
        id: "288",
        type: "TYPE_OBR",
        lines: [ 963 ],
        text: "Толомон",
        translate: "ордук бөдөҥ, талыы, дьоһун (крупный, лучший, отборный)"
        },
        {
        id: "289",
        type: "TYPE_OBR",
        lines: [ 3923 ],
        text: "Толугураччы",
        translate: "толугуруур тыастаахтык, чаастатык (шумно, громко биться, стучать)"
        },
        {
        id: "290",
        type: "TYPE_OBR",
        lines: [ 1475 ],
        text: "Томтолдьуй",
        translate: "томтоҕор быһыылан, үрдээн көһүн (стать выпуклым, возвышаться)"
        },
        {
        id: "291",
        type: "TYPE_OBR",
        lines: [ 419 ],
        text: "Тоноҕос эриэн",
        translate: "тоноҕоско майгылыыр саха оһуорун көрүҥэ (вид якутского орнамента, напоминающий позвонки)"
        },
        {
        id: "292",
        type: "TYPE_OBR",
        lines: [ 6193 ],
        text: "Торҕо сиигин сииктээ",
        translate: "төрдүгэр-төбөтүгэр тиийэ ымпыктаан-чымпыктаан быһааран бил (уяснить что-либо основательно, до конца)"
        },
        {
        id: "293",
        type: "TYPE_OBR",
        lines: [ 838 ],
        text: "Торумтуй",
        translate: "кыратык хараарбыт эбэтэр олус биллэр гына үүн (слегка почерневший, едва пробивающийся, об усиках)"
        },
        {
        id: "294",
        type: "TYPE_OBR",
        lines: [ 5399 ],
        text: "Туорайдаа",
        translate: "туохха эмэ туорайы оҥор, уур; тугу эмэ туорай гына түһэр,  туохха  эмэ  туора  түс (приделывать  поперечину  к  чему-л.; быть расположенным по ширине, поперёк чего-л.)"
        },
        {
        id: "295",
        type: "TYPE_OBR",
        lines: [ 5830 ],
        text: "Түллэҥнээ",
        translate: "күүрэн өрө-таҥнары түллүтэлээ; өрүтэ үллэҥнээ (сильно волноваться; вздыматься)"
        },
        {
        id: "296",
        type: "TYPE_OBR",
        lines: [ 5552 ],
        text: "Түрдэс гын",
        translate: "күүрэн  эмискэ  түүрэ  тарт,  түүрүлүн  (сжаться, съёжиться)"
        },
        {
        id: "297",
        type: "TYPE_OBR",
        lines: [ 372 ],
        text: "Тылбыҥнаа",
        translate: "ким эмэ диэки үчүгэмсийэн, үтүөмсүйэн хараххын кыаратан көрүтэлээ (кокетливо, игриво посматривать на кого-либо из-под опущенных век)"
        },
        {
        id: "298",
        type: "TYPE_OBR",
        lines: [ 18 ],
        text: "Тэлгэлдьийбэт",
        translate: "тэлгэммэт, тэнийбэт, ыһыллыбат (не растилается, не может быть разложен)"
        },
        {
        id: "299",
        type: "TYPE_OBR",
        lines: [ 3940 ],
        text: "Тэлэкэчиһэн",
        translate: "түргэнник, сытыытык-хотуутук хамсанан (двигаясь быстро, энергично, крутясь-вертясь)"
        },
        {
        id: "300",
        type: "TYPE_OBR",
        lines: [ 4365 ],
        text: "Тэмтээкэйдэһэн",
        translate: "икки өттүнэн байааттаҥнаан, уйуттубакка охтон, сууллан хаалыах курдук хааман (передвигаясь, раскачиваясь, шатаясь)"
        },
        {
        id: "301",
        type: "TYPE_OBR",
        lines: [ 3904 ],
        text: "Унаарыччы",
        translate: "бытаанык, наҕыллык (медленно, плавно)"
        },
        {
        id: "302",
        type: "TYPE_OBR",
        lines: [ 3992, 5310 ],
        text: "Уот татай",
        translate: "соһуйууну, сөҕүүнү бэлиэтиир саҥа аллайыы (междометие, выражающее сильное удивление, изумление)"
        },
        {
        id: "303",
        type: "TYPE_OBR",
        lines: [ 5553 ],
        text: "Үн",
        translate: "түөрт атах буолан эбэтэр  олорон  эрэ  сыылан  инниҥ  диэки сыҕарый (ползать на четвереньках, ползать)"
        },
        {
        id: "304",
        type: "TYPE_OBR",
        lines: [ 6009 ],
        text: "Үҥкүрүс-күөлэһис",
        translate: " сиргэ  сытан баран, эргичиҥнээн, төкүнүҥнээн сыҕарый (кататься, перекатываться, валяться на чём-л.)"
        },
        {
        id: "305",
        type: "TYPE_OBR",
        lines: [ 4549 ],
        text: "Үөкэй",
        translate: "көнө уонна үрдүк буол (быть прямым и высоким)"
        },
        {
        id: "306",
        type: "TYPE_OBR",
        lines: [ 670 ],
        text: "Үөкэй",
        translate: "көнө уонна үрдүк буол (быть прямым и высоким)"
        },
        {
        id: "307",
        type: "TYPE_OBR",
        lines: [ 3902 ],
        text: "Үрэйэ-сарайа",
        translate: "үрүө-тараа, арҕам-тарҕам (врассыпную, в разные стороны)"
        },
        {
        id: "308",
        type: "TYPE_OBR",
        lines: [ 5292 ],
        text: "Үрэлин",
        translate: "туох эмэ бүтүнү ыһан-тоҕон кэбис, онно-манна быраҕаттаа (разрушать, разорять что-л.)"
        },
        {
        id: "309",
        type: "TYPE_OBR",
        lines: [ 385 ],
        text: "Үс саха",
        translate: "саха диэн ааттаах барыта (Якуты, якутский народ)"
        },
        {
        id: "310",
        type: "TYPE_OBR",
        lines: [ 711 ],
        text: "Үүс-киис киргиллээҕэ",
        translate: "мааны түүлээх бастыҥа (лучшие, ценные меха)"
        },
        {
        id: "311",
        type: "TYPE_OBR",
        lines: [ 854 ],
        text: "Хабараан",
        translate: "олус хатан (раскатистый, далеко разносящийся)"
        },
        {
        id: "312",
        type: "TYPE_OBR",
        lines: [ 888 ],
        text: "Хабырыс",
        translate: "сиирэ хапсан, таарыйсан аас, кыһарый (задевать друг друга вскользь, притеснять, сталкиваться)"
        },
        {
        id: "313",
        type: "TYPE_OBR",
        lines: [ 158 ],
        text: "Хабырыс = хабырый",
        translate: "туох эмэ тугу эмэ кытта сиирэ хапсыыта, таарыйсыыта (задевать что-либо вскольз, поверхностно, по краю)"
        },
        {
        id: "314",
        type: "TYPE_OBR",
        lines: [ 384 ],
        text: "Халаана суох",
        translate: "аата-ахсаана суох, олус элбэх (бесчисленный, многочисленный)"
        },
        {
        id: "315",
        type: "TYPE_OBR",
        lines: [ 855 ],
        text: "Халаастаа",
        translate: "хаадьылаа, күлүү-элэк гын (шутить, насмехаться)"
        },
        {
        id: "316",
        type: "TYPE_OBR",
        lines: [ 14 ],
        text: "Халбалдьый",
        translate: "өттүккүнэн, самыыгынан хамсанан хаамп (ходить, двигая бедрами, покачиваясь)"
        },
        {
        id: "317",
        type: "TYPE_OBR",
        lines: [ 5962 ],
        text: "Халбарый",
        translate: "оннугуттан хамсаа, сыҕарый, тэйэн биэр (отодвинуться,  посторониться,  переместиться)"
        },
        {
        id: "318",
        type: "TYPE_OBR",
        lines: [ 1497 ],
        text: "Халдьыгыраччы",
        translate: "биир күдьүс халыгырыыр тыастаахтык (с монотонным журчанием)"
        },
        {
        id: "319",
        type: "TYPE_OBR",
        lines: [ 3928 ],
        text: "Халыгыраччы",
        translate: "халыгырыыр тыастаахтык, халыгырыыр курдук (громко звякая, брякая, бренча)"
        },
        {
        id: "320",
        type: "TYPE_OBR",
        lines: [ 852 ],
        text: "Халы-мааргы",
        translate: "куһаҕан көрүҥнээх, томороон (невзрачный, некрасивый)"
        },
        {
        id: "321",
        type: "TYPE_OBR",
        lines: [ 1434 ],
        text: "Ханньастыгас",
        translate: "иҥнэри барбыт, ханньайбыт (кривой, некрасиво искривленный)"
        },
        {
        id: "322",
        type: "TYPE_OBR",
        lines: [ 562 ],
        text: "Хаҥхас = хаҥхаччы",
        translate: "үөһээ өттүҥ улуутун, саллайан көстөрүн курдук (расширяясь кверху так, чтобы выглядеть в верхней части объемнее, чем в нижней)"
        },
        {
        id: "323",
        type: "TYPE_OBR",
        lines: [ 1253 ],
        text: "Ходьой",
        translate: "көбүс-көнөтүк туттан, чэпчэкитик ыстаҥалыы сырыт, ойуолуу сүүр (бегать с прискоком, вытягиваясь в длину)"
        },
        {
        id: "324",
        type: "TYPE_OBR",
        lines: [  4778 ],
        text: "Холугураччы",
        translate: "туохха эмэ охсуллан бүтэҥитик тыаһаа (издавать глухой дробный стук, ударяясь друг о друга)"
        },
        {
        id: "325",
        type: "TYPE_OBR",
        lines: [ 1474 ],
        text: "Хороҥноо",
        translate: "өрө тахсыталаа, чорбоҥноо (торчать, выступать)"
        },
        {
        id: "326",
        type: "TYPE_OBR",
        lines: [ 2261  ],
        text: "Хоһуҥураа",
        translate: "тыастаахтык тыын (храпеть)"
        },
        {
        id: "327",
        type: "TYPE_OBR",
        lines: [ 394 ],
        text: "Чаабырҕаа",
        translate: "тохтообокко элбэҕи саҥар (много говорить о чем-либо)"
        },
        {
        id: "328",
        type: "TYPE_OBR",
        lines: [ 216, 4369 ],
        text: "Чаллырҕаччы",
        translate: "чаллыргыыр тыастаахтык (с хлюпающими, чавкающими звуками)"
        },
        {
        id: "329",
        type: "TYPE_OBR",
        lines: [ 5569 ],
        text: "Чиккэй",
        translate: "көбүс-көнөтүк тардыллыбыт, тыҥаабыт  курдук  көнө буол (быть туго натянутым, не свисать)"
        },
        {
        id: "330",
        type: "TYPE_OBR",
        lines: [  218 ],
        text: "Чөллүргэччи",
        translate: "хойуутук, дэлэйдик таммалыыр убаҕаһы этэргэ (о какой-либо жидкости, часто, густо и обильно капающем)"
        },
        {
        id: "331",
        type: "TYPE_OBR",
        lines: [ 2216  ],
        text: "Чөмчөрүс гын",
        translate: "хоп-дьип, дьыпса буолан көһүн (быть, казаться аккуратным, опрятным)"
        },
        {
        id: "332",
        type: "TYPE_OBR",
        lines: [ 248, 1010, 5517 ],
        text: "Чугуруй = чугуй",
        translate: "инниҥ диэки баран  иһэн  төттөрү  түс,  кэннигинэн  бар (пятиться, отступать, отходить назад)"
        },
        {
        id: "333",
        type: "TYPE_OBR",
        lines: [ 374 ],
        text: "Чуоҕуй",
        translate: "ханна эмэ муһун, элбэх буолан тоҕуоруй (собираться, сходиться, скучиваться где-либо)"
        },
        {
        id: "334",
        type: "TYPE_OBR",
        lines: [ 397 ],
        text: "Чуубурҕаа",
        translate: "“чууп-чууп” дииргэ маарынныыр синньигэс саҥаны таһаар (издавать высокие пищащие звуки, пищать. попискивать)"
        },
        {
        id: "335",
        type: "TYPE_OBR",
        lines: [ 6558 ],
        text: "Чыҥырҕастаах=чыҥырҕаа",
        translate: "төһө эмэ кэм буола-буола хатыланар хатан тыаһы таһаар (издавать громкие, звонкие, равномерно повторяющиеся звуки)"
        },
        {
        id: "336",
        type: "TYPE_OBR",
        lines: [ 541 ],
        text: "Эбир дуоссун",
        translate: "эриэннии чуоҕурдаах, бээтинэлэрдээх (крапчатый, пестрый, рябой)"
        },
        {
        id: "337",
        type: "TYPE_OBR",
        lines: [6387 ],
        text: "Эбир-дьаҕыл",
        translate: "биир күрүс баһыйар өҥтөн уратыланар элбэх чуоҕурдаах, бээтинэлээх (имеющий множество пятен, крапин другого цвета по отношению к основной окраске, пестрый, крапчатый)"
        },
        {
        id: "338",
        type: "TYPE_OBR",
        lines: [ 1739 ],
        text: "Элэкис гын",
        translate: "эмискэ хараххар көстөн ыл (промелькнуть перед глазами, показаться на мгновение)."
        },
        {
        id: "339",
        type: "TYPE_OBR",
        lines: [ 425 ],
        text: "Элэҥнээ",
        translate: "түргэнник төттөрү-таары бар-кэл, элэгэлдьий (носиться, двигаться снова туда-сюда)"
        },
        {
        id: "340",
        type: "TYPE_OBR",
        lines: [ 984 ],
        text: "Эҥиһит",
        translate: "ыраахха диэри дорҕоонноохтук тыас таһаар, ньириһит (издавать гулкий, громкий раскатистый звук)"
        },
        {
        id: "341",
        type: "TYPE_OBR",
        lines: [ 1323 ],
        text: "Эрилик-турулук көр",
        translate: "уоттаммыт хараххынан сытыытык көр (пучить глаза, ясно, четко видеть)"
        },
        {
        id: "342",
        type: "TYPE_OBR",
        lines: [ 691 ],
        text: "Эрилкэй = арылхай",
        translate: "киэҥ, ыраас уонна сырдык (харах туһунан) (большие, ясные и светлые (о глазах))"
        },
        {
        id: "343",
        type: "TYPE_OBR",
        lines: [ 308 ],
        text: "Эрэдэһин",
        translate: "эриллэн оҥоһуллубут (крученый)"
        },
        
    /* НУУЧЧА ТЫЛЫТТАН КИИРИИ ТЫЛЛАР (ЗАИМСТВОВАННЫЕ ИЗ РУССКОГО ЯЗЫКА СЛОВА) */
    {
        id: "344",
        type: "TYPE_RUS",
        lines: [  60, 3200, 3874, 5279 ],
        text: "Аалай",
        translate: "алый"
        },
        {
        id: "345",
        type: "TYPE_RUS",
        lines: [ 696 ],
        text: "Аалыскай иҥнэ",
        translate: "английская иголка"
        },
        {
        id: "346",
        type: "TYPE_RUS",
        lines: [ 2925 ],
        text: "Агыраада",
        translate: "ограда"
        },
        {
        id: "347",
        type: "TYPE_RUS",
        lines: [ 4258, 5228 ],
        text: "Ампаар",
        translate: "амбар"
        },
        {
        id: "348",
        type: "TYPE_RUS",
        lines: [ 2718 ],
        text: "Аркыып",
        translate: "архив"
        },
        {
        id: "349",
        type: "TYPE_RUS",
        lines: [ ],
        text: "Атамаан",
        translate: "атаман. 455"
        },
        {
        id: "350",
        type: "TYPE_RUS",
        lines: [ 130 ],
        text: "Баара",
        translate: "пара"
        },
        {
        id: "351",
        type: "TYPE_RUS",
        lines: [ 154 ],
        text: "Балаакка",
        translate: "палатка"
        },
        {
        id: "352",
        type: "TYPE_RUS",
        lines: [ 3390 ],
        text: "Барабаан",
        translate: "барабан"
        },
        {
        id: "353",
        type: "TYPE_RUS",
        lines: [ 6498 ],
        text: "Баһаар",
        translate: "пожар"
        },
        {
        id: "354",
        type: "TYPE_RUS",
        lines: [ 3590 ],
        text: "Бииккэ",
        translate: "вилка"
        },
        {
        id: "355",
        type: "TYPE_RUS",
        lines: [ 2725, 4414 ],
        text: "Бирисээгэ",
        translate: "присяга"
        },
        {
        id: "356",
        type: "TYPE_RUS",
        lines: [ 334 ],
        text: "Бирээмэ",
        translate: "время"
        },
        {
        id: "357",
        type: "TYPE_RUS",
        lines: [ 55 ],
        text: "Биэлэй",
        translate: "белый"
        },
        {
        id: "358",
        type: "TYPE_RUS",
        lines: [ 56, 807, 1890, 5387 ],
        text: "Биэрэк",
        translate: "берег"
        },
        {
        id: "359",
        type: "TYPE_RUS",
        lines: [ 4531 ],
        text: "Биэрэстэ",
        translate: "верста"
        },
        {
        id: "360",
        type: "TYPE_RUS",
        lines: [ 4161, 5735, 6423 ],
        text: "Бокулуон",
        translate: "поклон"
        },
        {
        id: "361",
        type: "TYPE_RUS",
        lines: [ 3936 ],
        text: "Бокуойа суох",
        translate: "без покоя"
        },
        {
        id: "362",
        type: "TYPE_RUS",
        lines: [ 1391 ],
        text: "Боруобалаа",
        translate: "попробуй"
        },
        {
        id: "363",
        type: "TYPE_RUS",
        lines: [ 667 ],
        text: "Боруобалаах",
        translate: "проба"
        },
        {
        id: "364",
        type: "TYPE_RUS",
        lines: [ 6395 ],
        text: "Боруок",
        translate: "порог"
        },
        {
        id: "365",
        type: "TYPE_RUS",
        lines: [ 102 ],
        text: "Бостуочунай Сибиир",
        translate: "Восточная Сибирь"
        },
        {
        id: "366",
        type: "TYPE_RUS",
        lines: [ 97 ],
        text: "Босуом",
        translate: "фасон"
        },
        {
        id: "367",
        type: "TYPE_RUS",
        lines: [ 4605 ],
        text: "Бөтүүк",
        translate: "петух"
        },
        {
        id: "368",
        type: "TYPE_RUS",
        lines: [ 4852 ],
        text: "Буойун",
        translate: "воин"
        },
        {
        id: "369",
        type: "TYPE_RUS",
        lines: [ 101 ],
        text: "Буолатынан",
        translate: "волей"
        },
        {
        id: "370",
        type: "TYPE_RUS",
        lines: [ 5596 ],
        text: "Буолунай",
        translate: "вольный"
        },
        {
        id: "371",
        type: "TYPE_RUS",
        lines: [ 98, 103 ],
        text: "Буолунай",
        translate: "вольный"
        },
        {
        id: "372",
        type: "TYPE_RUS",
        lines: [ 5324 ],
        text: "Буурай",
        translate: "бурый"
        },
        {
        id: "373",
        type: "TYPE_RUS",
        lines: [ 2990, 3836 ],
        text: "Бууса",
        translate: "пуще прежнего"
        },
        {
        id: "374",
        type: "TYPE_RUS",
        lines: [ 5775 ],
        text: "Бүлүүһэ",
        translate: "блюдце"
        },
        {
        id: "375",
        type: "TYPE_RUS",
        lines: [ 2717 ],
        text: "Бүрүстүөл",
        translate: "престол"
        },
        {
        id: "376",
        type: "TYPE_RUS",
        lines: [ 2162  ],
        text: "Бэчээт",
        translate: "печать"
        },
        {
        id: "377",
        type: "TYPE_RUS",
        lines: [ 1064 ],
        text: "Дакаастаа",
        translate: "докажи"
        },
        {
        id: "378",
        type: "TYPE_RUS",
        lines: [ 865, 3771 ],
        text: "Долуой",
        translate: "долой"
        },
        {
        id: "379",
        type: "TYPE_RUS",
        lines: [ 3490 ],
        text: "Доппуруостаа",
        translate: "допрашивать"
        },
        {
        id: "380",
        type: "TYPE_RUS",
        lines: [ 555, 1045, 5735  ],
        text: "Дорообо",
        translate: "здравствуй"
        },
        {
        id: "381",
        type: "TYPE_RUS",
        lines: [ 1383 ],
        text: "Дуоһанас",
        translate: "должность"
        },
        {
        id: "382",
        type: "TYPE_RUS",
        lines: [ 3841 ],
        text: "Дуумайдаа",
        translate: "думать"
        },
        {
        id: "383",
        type: "TYPE_RUS",
        lines: [ 1445, 5383 ],
        text: "Дэриэтиньньик",
        translate: "от «еретик»; в значении: чудовище, зомби"
        },
        {
        id: "384",
        type: "TYPE_RUS",
        lines: [ 3360, 4142, 6393 ],
        text: "Дьаакыр",
        translate: "якорь"
        },
        {
        id: "385",
        type: "TYPE_RUS",
        lines: [ 127 ],
        text: "Дьааһык",
        translate: "ящик"
        },
        {
        id: "386",
        type: "TYPE_RUS",
        lines: [ 2719, 4889 ],
        text: "Дьыала",
        translate: "дело"
        },
        {
        id: "387",
        type: "TYPE_RUS",
        lines: [ 585 ],
        text: "Испиир",
        translate: "спирт"
        },
        {
        id: "388",
        type: "TYPE_RUS",
        lines: [ 2956 ],
        text: "Испииһэк",
        translate: "список"
        },
        {
        id: "389",
        type: "TYPE_RUS",
        lines: [ 600, 4219 ],
        text: "Истиэнэ",
        translate: "стена"
        },
        {
        id: "390",
        type: "TYPE_RUS",
        lines: [ 741 ],
        text: "Киил",
        translate: "киль, кильевой"
        },
        {
        id: "391",
        type: "TYPE_RUS",
        lines: [ 118, 2662, 3320, 5734 ],
        text: "Кинээс",
        translate: "князь"
        },
        {
        id: "392",
        type: "TYPE_RUS",
        lines: [ 1383 ],
        text: "Кинээс-кулуба",
        translate: "князь-глава"
        },
        {
        id: "393",
        type: "TYPE_RUS",
        lines: [ 2722 ],
        text: "Кириэс",
        translate: "крест"
        },
        {
        id: "394",
        type: "TYPE_RUS",
        lines: [ 4137 ],
        text: "Көлөһө",
        translate: "колесо"
        },
        {
        id: "395",
        type: "TYPE_RUS",
        lines: [ 122 ],
        text: "Кулуба",
        translate: "глава"
        },
        {
        id: "396",
        type: "TYPE_RUS",
        lines: [ 2718, 4889 ],
        text: "Кумааҕы",
        translate: "бумага"
        },
        {
        id: "397",
        type: "TYPE_RUS",
        lines: [ 6434 ],
        text: "Кумаар",
        translate: "комар"
        },
        {
        id: "398",
        type: "TYPE_RUS",
        lines: [ 5475 ],
        text: "Куоластаа",
        translate: "подавать голос"
        },
        {
        id: "399",
        type: "TYPE_RUS",
        lines: [ 2710, 5317, 6499 ],
        text: "Куорат",
        translate: "город"
        },
        {
        id: "400",
        type: "TYPE_RUS",
        lines: [ 2721 ],
        text: "Куоссун",
        translate: "от «коршун»; в знач: перо"
        },
        {
        id: "401",
        type: "TYPE_RUS",
        lines: [ 2520 ],
        text: "Куоттук",
        translate: "кортик"
        },
        {
        id: "402",
        type: "TYPE_RUS",
        lines: [ 574, 4106 ],
        text: "Курустаал",
        translate: "хрусталь"
        },
        {
        id: "403",
        type: "TYPE_RUS",
        lines: [ 1040 ],
        text: "Курустаал чөмчүүк",
        translate: "хрустальный жемчуг"
        },
        {
        id: "404",
        type: "TYPE_RUS",
        lines: [ 4607 ],
        text: "Куурусса",
        translate: "курица"
        },
        {
        id: "405",
        type: "TYPE_RUS",
        lines: [ 900 ],
        text: "Кылаат",
        translate: "клад"
        },
        {
        id: "406",
        type: "TYPE_RUS",
        lines: [ 4450 ],
        text: "Кырааскалаах",
        translate: "с краской"
        },
        {
        id: "407",
        type: "TYPE_RUS",
        lines: [ 718, 3500 ],
        text: "Кырыыбалыы",
        translate: "криво"
        },
        {
        id: "408",
        type: "TYPE_RUS",
        lines: [ 2661 ],
        text: "Лаадан",
        translate: "ладан"
        },
        {
        id: "409",
        type: "TYPE_RUS",
        lines: [ 648 ],
        text: "Лааппы",
        translate: "лавка"
        },
        {
        id: "410",
        type: "TYPE_RUS",
        lines: [ 5686 ],
        text: "Лиэһэй",
        translate: "леший"
        },
        {
        id: "411",
        type: "TYPE_RUS",
        lines: [ 1625  ],
        text: "Луоска = ньуоска",
        translate: "ложка"
        },
        {
        id: "412",
        type: "TYPE_RUS",
        lines: [ 310, 901 ],
        text: "Манньыат",
        translate: "монета"
        },
        {
        id: "413",
        type: "TYPE_RUS",
        lines: [ 3550 ],
        text: "Матыарыйа",
        translate: "материя"
        },
        {
        id: "414",
        type: "TYPE_RUS",
        lines: [ 3190 ],
        text: "Мөһүүрэ",
        translate: "мишура"
        },
        {
        id: "415",
        type: "TYPE_RUS",
        lines: [ 3110, 4349, 4983 ],
        text: "Муора",
        translate: "море"
        },
        {
        id: "416",
        type: "TYPE_RUS",
        lines: [ 605 ],
        text: "Муоста",
        translate: "мост, пол"
        },
        {
        id: "417",
        type: "TYPE_RUS",
        lines: [ 2724, 4114 ],
        text: "Мэтириэт",
        translate: "портрет"
        },
        {
        id: "418",
        type: "TYPE_RUS",
        lines: [ 736, 1546, 3110  ],
        text: "Мээчик",
        translate: "мяч"
        },
        {
        id: "419",
        type: "TYPE_RUS",
        lines: [ 1348, 2089 ],
        text: "Наада",
        translate: "от «надо»; в значении: надобность"
        },
        {
        id: "420",
        type: "TYPE_RUS",
        lines: [ 3420 ],
        text: "Нэhилиэк",
        translate: "наслег"
        },
        {
        id: "421",
        type: "TYPE_RUS",
        lines: [ 3590 ],
        text: "Ньуоска",
        translate: " ложка"
        },
        {
        id: "422",
        type: "TYPE_RUS",
        lines: [ 864 ],
        text: "Оруодьа",
        translate: "рота"
        },
        {
        id: "423",
        type: "TYPE_RUS",
        lines: [ 1935  ],
        text: "Оруоска",
        translate: "розга"
        },
        {
        id: "424",
        type: "TYPE_RUS",
        lines: [ 862 ],
        text: "Оспуордас",
        translate: "спорить"
        },
        {
        id: "425",
        type: "TYPE_RUS",
        lines: [ 649, 3590 ],
        text: "Остуол",
        translate: "стол"
        },
        {
        id: "426",
        type: "TYPE_RUS",
        lines: [ 655 ],
        text: "Остуорас",
        translate: "сторож"
        },
        {
        id: "427",
        type: "TYPE_RUS",
        lines: [ 205 ],
        text: "Оһуор",
        translate: "узор"
        },
        {
        id: "428",
        type: "TYPE_RUS",
        lines: [ 41  ],
        text: "Очуос",
        translate: "утёс"
        },
        {
        id: "429",
        type: "TYPE_RUS",
        lines: [ 2723, 3901 ],
        text: "Өрүөл",
        translate: "орел"
        },
        {
        id: "430",
        type: "TYPE_RUS",
        lines: [ 2766 ],
        text: "Саарыстыба",
        translate: "царство"
        },
        {
        id: "431",
        type: "TYPE_RUS",
        lines: [ 5325, 6286 ],
        text: "Сибиир",
        translate: "Сибирь"
        },
        {
        id: "432",
        type: "TYPE_RUS",
        lines: [ 635 ],
        text: "Сиилинэй",
        translate: "сильный"
        },
        {
        id: "433",
        type: "TYPE_RUS",
        lines: [ 630 ],
        text: "Сиэркилэ таас",
        translate: "зеркало"
        },
        {
        id: "434",
        type: "TYPE_RUS",
        lines: [ 203   ],
        text: "Сиэрэй солко",
        translate: "серый шёлк"
        },
        {
        id: "435",
        type: "TYPE_RUS",
        lines: [ 1265 ],
        text: "Содуом",
        translate: "содом"
        },
        {
        id: "436",
        type: "TYPE_RUS",
        lines: [ 2726, 4408, 5009, 5752 ],
        text: "Сокуон",
        translate: "закон"
        },
        {
        id: "437",
        type: "TYPE_RUS",
        lines: [ 203, 3260, 5027, 5279 ],
        text: "Солко",
        translate: "шелк"
        },
        {
        id: "438",
        type: "TYPE_RUS",
        lines: [ ],
        text: "Солотуулаах",
        translate: "золотой   3590"
        },
        {
        id: "439",
        type: "TYPE_RUS",
        lines: [ 1347 ],
        text: "Сыал",
        translate: "цель"
        },
        {
        id: "440",
        type: "TYPE_RUS",
        lines: [ 5300 ],
        text: "Сыаналаа",
        translate: "оценивать"
        },
        {
        id: "441",
        type: "TYPE_RUS",
        lines: [ 5986 ],
        text: "Сэлээппэ",
        translate: "шляпа"
        },
        {
        id: "442",
        type: "TYPE_RUS",
        lines: [ 2743, 5005 ],
        text: "Сэрэбиэй",
        translate: "от: жребий; в знач.: судьба"
        },
        {
        id: "443",
        type: "TYPE_RUS",
        lines: [ 4285 ],
        text: "Тайҕа",
        translate: "тайга"
        },
        {
        id: "444",
        type: "TYPE_RUS",
        lines: [ 1065 ],
        text: "Топпуруостаа",
        translate: "допроси"
        },
        {
        id: "445",
        type: "TYPE_RUS",
        lines: [ 4121, 6492 ],
        text: "Торуоска",
        translate: "трость"
        },
        {
        id: "446",
        type: "TYPE_RUS",
        lines: [ 626 ],
        text: "Түрмэ",
        translate: "тюрьма"
        },
        {
        id: "447",
        type: "TYPE_RUS",
        lines: [ 1445, 3590, 5559 ],
        text: "Тэриэккэ = тэриэлкэ",
        translate: "тарелка"
        },
        {
        id: "448",
        type: "TYPE_RUS",
        lines: [ 4388 ],
        text: "Хааппыла",
        translate: "капля"
        },
        {
        id: "449",
        type: "TYPE_RUS",
        lines: [ 4405 ],
        text: "Хабала",
        translate: "кабала"
        },
        {
        id: "450",
        type: "TYPE_RUS",
        lines: [ 982 ],
        text: "Халааныскай ыстаан",
        translate: "голландские штаны"
        },
        {
        id: "451",
        type: "TYPE_RUS",
        lines: [ 1466 ],
        text: "Халымыайка",
        translate: "каламейка (вид ткани)"
        },
        {
        id: "452",
        type: "TYPE_RUS",
        lines: [ 4301 ],
        text: "Халыым",
        translate: "калым"
        },
        {
        id: "453",
        type: "TYPE_RUS",
        lines: [ 867, 3380 ],
        text: "Хамаанда",
        translate: "команда"
        },
        {
        id: "454",
        type: "TYPE_RUS",
        lines: [ 127 ],
        text: "Хампа",
        translate: "канфа (китайский шелк)"
        },
        {
        id: "455",
        type: "TYPE_RUS",
        lines: [ 886 ],
        text: "Хамчаакы",
        translate: "Камчатка"
        },
        {
        id: "456",
        type: "TYPE_RUS",
        lines: [ 4431, 5036, 5663 ],
        text: "Хармаан",
        translate: "карман"
        },
        {
        id: "457",
        type: "TYPE_RUS",
        lines: [ 86 ],
        text: "Хормуоньньа",
        translate: "гармонь"
        },
        {
        id: "458",
        type: "TYPE_RUS",
        lines: [ 6360 ],
        text: "Хоруол",
        translate: "король"
        },
        {
        id: "459",
        type: "TYPE_RUS",
        lines: [ 4492 ],
        text: "Хоруоҥка",
        translate: "карельки"
        },
        {
        id: "460",
        type: "TYPE_RUS",
        lines: [ 2520 ],
        text: "Чааньньык",
        translate: "чайник"
        },
        {
        id: "461",
        type: "TYPE_RUS",
        lines: [ 3620 ],
        text: "Чаас",
        translate: "часть"
        },
        {
        id: "462",
        type: "TYPE_RUS",
        lines: [ 1300, 6673 ],
        text: "Чааскы",
        translate: "чашка"
        },
        {
        id: "463",
        type: "TYPE_RUS",
        lines: [ 75 ],
        text: "Чиэрбэ",
        translate: "червь"
        },
        {
        id: "464",
        type: "TYPE_RUS",
        lines: [ 3020 ],
        text: "Чиэрэс",
        translate: "через"
        },
        {
        id: "465",
        type: "TYPE_RUS",
        lines: [ 116 ],
        text: "Чиэрэстэтэлээн",
        translate: "через"
        },
        {
        id: "466",
        type: "TYPE_RUS",
        lines: [ 3028, 5793 ],
        text: "Чиэрэстээ",
        translate: "от «через»; пролететь через что-то"
        },
        {
        id: "467",
        type: "TYPE_RUS",
        lines: [ 3880 ],
        text: "Чыыстай",
        translate: "чистый"
        },
        {
        id: "468",
        type: "TYPE_RUS",
        lines: [ 2720 ],
        text: "Чэрэниилэ",
        translate: "чернила"
        },
        {
        id: "469",
        type: "TYPE_RUS",
        lines: [ 4434, 4527 ],
        text: "Ырай",
        translate: "рай"
        },
        {
        id: "470",
        type: "TYPE_RUS",
        lines: [ 1463 ],
        text: "Ыстаан",
        translate: "штаны"
        },
        {
        id: "471",
        type: "TYPE_RUS",
        lines: [ 4042 ],
        text: "Ыстакаан",
        translate: "стакан"
        },
        {
        id: "472",
        type: "TYPE_RUS",
        lines: [ 4402 ],
        text: "Эбээһинэс",
        translate: "обязанность"
        },
        {
        id: "473",
        type: "TYPE_RUS",
        lines: [ 4196 ],
        text: "Эппиэт",
        translate: "ответ"
        },
        {
        id: "474",
        type: "TYPE_RUS",
        lines: [ 1063 ],
        text: "Эппиэттээ",
        translate: "ответь"
        },
        
    /* СОМОҔО ДОМОХТОР (ФРАЗЕОЛОГИЗМЫ) */
    {
        id: "475",
        type: "TYPE_FRAZ",
        lines: [ 5349 ],
        text: "Биир сымыыт ханна сытыйбатаҕай",
        translate: "где наша не пропадала! – букв. где не сгнивает одно яйцо"
        },
        {
        id: "476",
        type: "TYPE_FRAZ",
        lines: [ 934 ],
        text: "Бөлөнөххө мөскөй, тарга дагдай",
        translate: "баайдык-тоттук олор (живи в богатстве и изобилии)"
        },
        {
        id: "477",
        type: "TYPE_FRAZ",
        lines: [ 3852 ],
        text: "Быарым тулаайаҕа",
        translate: "күүтүүлээх-кэтэһиилээх, күндүттэн күндү (любимый, желанный, единственный)"
        },
        {
        id: "478",
        type: "TYPE_FRAZ",
        lines: [ 1379 ],
        text: "Илбистээх бэлэстээх",
        translate: "иччилээх тыллаах (говорящий вещие слова)"
        },
        {
        id: "479",
        type: "TYPE_FRAZ",
        lines: [ 1030 ],
        text: "Иҥиир тараһалаа, этирик түөстээ",
        translate: "баттаа, көлөһүннээ (довести до край¬него истощения, изнурить)"
        },
        {
        id: "480",
        type: "TYPE_FRAZ",
        lines: [ 1503 ],
        text: "Киһи буолар кэскилгиттэн кэбэлитиэм, сүөһү буолар төлкөҕүнэн төнүннэриэм",
        translate: "үчүгэй олоҕу олорор аналгын алдьатыам (разрушу перспективу на будущее, на достойную жизнь)"
        },
        {
        id: "481",
        type: "TYPE_FRAZ",
        lines: [ 3610  ],
        text: "Көрдөр хараҕым дьүккэтэ буолбут, көтүрдэр тииhим миилэтэ тэҥнээх, сүрэхпиттэн быстан түспүт сүрэҕим ытарҕата холобурдаах, быарбыттан быстан түспүт быарым тулаайаҕа холоонноох",
        translate: "киhиэхэ соҕотох мааныламмыт оҕото эбэтэр кыыла (единственное, любимое дитя или животное у человека)"
        },
        {
        id: "482",
        type: "TYPE_FRAZ",
        lines: [ 3847 ],
        text: "Көрдөр хараҕым дьүккэтэ, көтүрдэр тииһим миилэтэ",
        translate: "саамай харыстыыр, таптыыр оҕом (мой любимый, единственный (обычно о детях))"
        },
        {
        id: "483",
        type: "TYPE_FRAZ",
        lines: [ 3580 ],
        text: "Көхсө көнньүөрэн хаалла, быара манньыйан хаалла",
        translate: "дуоhуйуу, астыныы (наслаждение, блаженство)"
        },
        {
        id: "484",
        type: "TYPE_FRAZ",
        lines: [ 906 ],
        text: "Көхсүнү көнньүөрт",
        translate: "астын-дуоһуй, санааҥ табылын (быть удовлетворенным, утешаться, успокаиваться)"
        },
        {
        id: "485",
        type: "TYPE_FRAZ",
        lines: [ 1507 ],
        text: "Күлэ-күлэ күлгүн буккуйуом, ооньньуу-ооньньуу уоккун умуруоруом!",
        translate: "өлөрүөм-өһөрүөм (уничтожу в пух и прах)"
        },
        {
        id: "486",
        type: "TYPE_FRAZ",
        lines: [ 1203 ],
        text: "Күөрт ыттар күлүү гына сылдьыахтара, эриэн ыттар элэк гына сылдьыахтара",
        translate: "киһи барыта күлүү-элэк гыныа (все будут насмехаться, издеваться)"
        },
        {
        id: "487",
        type: "TYPE_FRAZ",
        lines: [ 2743 ],
        text: "Окко түспүт оҥоһуум, сиргэ түспүт сэрэбиэйим",
        translate: "төлкөм, дьылҕам (судьба, рок)"
        },
        {
        id: "488",
        type: "TYPE_FRAZ",
        lines: [ 3650  ],
        text: "Охтооҕор түргэнник, түүтээҕэр чэпчэкитик айаннаан иhин",
        translate: "эрэйэ суох, түргэнник айаннаан (ехать быстро, благополучно, без препятствий дороги)"
        },
        {
        id: "489",
        type: "TYPE_FRAZ",
        lines: [ 5018 ],
        text: "Өлбөт үөстээх, быстыбат тыыннаах киһи эбит",
        translate: "өлүө буоллар өлөн биэрбэт; өлөрдүү охтон баран, өлөн быстыбат, тулуйар (живучий, очень выносливый, жизнеспособный)"
        },
        {
        id: "490",
        type: "TYPE_FRAZ",
        lines: [ 905 ],
        text: "Санаа тарҕат",
        translate: "санааҥ түспүтүн тугунан эмэ аралдьытан аһар (отвлекаться от неприятных мыслей, снимать напряжение)"
        },
        {
        id: "491",
        type: "TYPE_FRAZ",
        lines: [ 3988 ],
        text: "Санаатын тарҕатта",
        translate: "санааҥ түспүтүн тугунан эмэ аралдьытан аһар (отвлекаться от неприятных мыслей, снимать напряжение)"
        },
        {
        id: "492",
        type: "TYPE_FRAZ",
        lines: [ 3850 ],
        text: "Сүрэҕим ытарҕата",
        translate: "күндүттэн күндү, туохха да тэҥэ суох күндү (самый дорогой, несравненный, ненаглядный)"
        },
        {
        id: "493",
        type: "TYPE_FRAZ",
        lines: [ 3420 ],
        text: "Тоҕус уоннарын туруйалаан туолан",
        translate: "тоҕус уон саастарын туолбут кырдьаҕастар (90-летние, отличающиеся долголетием)"
        },
        {
        id: "494",
        type: "TYPE_FRAZ",
        lines: [ 4382 ],
        text: "Төһө да үрүт уйаланнаргын, ордук мутуктаннаргын",
        translate: "лаппа чорбойор, үрдүк да буолларгын (хотя ты на голову выше, хотя значительно превосходишь)"
        },
        {
        id: "495",
        type: "TYPE_FRAZ",
        lines: [ 2280 ],
        text: "Түөрэх кэбиһэн, Төлкө ууран барыам этэ!",
        translate: "түөрэҕи быраҕан инникигин билгэлээн көр (гадать, строить догадки, предположения)"
        },
        {
        id: "496",
        type: "TYPE_FRAZ",
        lines: [ 3170 ],
        text: "Умса түстэхпитинэ илин өттүбүтүттэн өйөөбүл баҕана буолсуохпут, тиэрэ түстэхпитинэ кэлин өттүбүтүттэн тирээбил баҕана буолуохпут!",
        translate: "бэйэ-бэйэҕэ көмө буоларга андаҕар (клятва, обещание, слова поддержки, о помощи другому в любой ситуации)"
        },
        {
        id: "497",
        type: "TYPE_FRAZ",
        lines: [ 4031 ],
        text: "Уҥуоҕа халыр босхо барда",
        translate: "үөрэн, долгуйан илиитэ-атаҕа салыбырыыр, титириир, уҥуоҕа хамсыыр (Поджилки трясутся)"
        },
        {
        id: "498",
        type: "TYPE_FRAZ",
        lines: [ 4066 ],
        text: "Уодай (уодан) хаанын хааннанна",
        translate: "олус киҥнэннэ, суостанна (стала гневной, свирепой, грозной)"
        },
        {
        id: "499",
        type: "TYPE_FRAZ",
        lines: [ 5046 ],
        text: "Уолан быстар уулаах, Олохсуйан хагдарыйар оттоох, Охтон баранар мастаах, Сиҥнэн сиэмэтэ быстыбат",
        translate: "уйгута-быйаҥа бараммакка алла турар сир"
        },
        {
        id: "500",
        type: "TYPE_FRAZ",
        lines: [ 3040 ],
        text: "Хайырҕахтаах хара быара хамсаата, нохтоолоох тойон сүрэҕэ долгуйда",
        translate: "киhи ис туругун бэлиэтиир (внутреннее эмоциональное состояние человека)"
        },
        {
        id: "501",
        type: "TYPE_FRAZ",
        lines: [ 909 ],
        text: "Халыҥ хаһанан хаччы кэбиһэн, суон саалынан суомас кэбиһэн, дьоһун мүһэнэн мохсуо уурунан",
        translate: "баайдык-тоттук (жить в изобилии)"
        },
        {
        id: "502",
        type: "TYPE_FRAZ",
        lines: [ 3770 ],
        text: "Хат таманнан, халын хаhалан, суон сааллан",
        translate: "баайдык-тоттук (жить в изобилии)"
        },
        {
        id: "503",
        type: "TYPE_FRAZ",
        lines: [ 1335 ],
        text: "Хоро тойуга",
        translate: "өйдөммөт, атын тыллаах ырыа-тойук (песня на непонятном, неизвестном языке)"
        },
        {
        id: "504",
        type: "TYPE_FRAZ",
        lines: [ 4400 ],
        text: "Ыйаах бөҕө ытыспытыгар, сокуон бөҕө сутурукпутугар, эбээһинэс бөҕө илиибитигэр буоллаҕа",
        translate: "кырыктаах, бардам дьон буоллахпыт (злобные, грозные, свирепые, дерзкие)"
        },
        {
        id: "505",
        type: "TYPE_FRAZ",
        lines: [ 3400 ],
        text: "Эбэ хараҕын харахтанан, уодай хаанын хааннанан",
        translate: "кыыhырар хаана киирбит (выходит из себя, то есть показывает свою раздражимость, агрессию)"
        },
        {
        id: "506",
        type: "TYPE_FRAZ",
        lines: [ 4063 ],
        text: "Эһэ сирэйин сирэйдэннэ, эбэ хараҕын харахтанна",
        translate: "суостанна, ынырык быһыыланна (стала грозной, внушающей страх)"
        },
        {
        id: "507",
        type: "TYPE_FRAZ",
        lines: [ 4270 ],
        text: "Эрбии биитин курдук",
        translate: "тэбис-тэҥнэр (равные во всех отношениях)"
        },
        {
        id: "508",
        type: "TYPE_FRAZ",
        lines: [ 3730 ],
        text: "Эриэн ыт элэгэ буолсубун, күөрт ыт күлүүтэ буолсубун",
        translate: "киһи барыта күлүү-элэк гыныа (все будут насмехаться, издеваться)"
        },
        
    /* ӨС ХОҺООННОРО (ПОСЛОВИЦЫ И ПОГОВОРКИ) */
    {
        id: "509",
        type: "TYPE_POSL",
        lines: [ 3854 ],
        text: "Уот кыымнаах, сурт кэриэстээх, өтөх төҥүргэстээх.",
        translate: "(Огонь имеет искру, старая усадьба имеет пни)."
    },
    {
        id: "510",
        type: "TYPE_POSL",
        lines: [ 1396 ],
        text: "Үгүс тыл сымсах, аҕыйах тыл миньньигэс!",
        translate: "(Многословие претит; дословно: много слов – невкусно, мало слов – вкусно)."
    },
    {
        id: "511",
        type: "TYPE_POSL",
        lines: [ 1398 ],
        text: "Үтүө киһи тыла биир, үчүгэй ат кымньыыта соҕотох.",
        translate: "(Многословие претит; дословно: у доброго человека – одно слово, у хорошего коня – один кнут)."
    },
    /* ТЭҤНЭБИЛЛЭР (СРАВНЕНИЯ) */
    {
        id: "512",
        type: "TYPE_SRAV",
        lines: [ 759, 2313, 4459, 4495 ],
        text: "Улахан үрэх тоҕойдуу түһэн турарын <b>курдук</b><br>Хомуһуннаах кураахтаах саатын...",
        translate: "Волшебный лук, изогнутый <b>подобно</b><br>Излучине большой реки..."
    },
    {
        id: "513",
        type: "TYPE_SRAV",
        lines: [ 765 ],
        text: "Сайыҥҥы кулун кымыһыгар ооньньуур<br>Бойон киһи сототун уҥуоҕун<br>Сулуйа баттаабыт <b>курдук</b>,<br>Хонуоһуннаах кулан-дьорҕоон<br>Оноҕостордоох эбит.",
        translate: "<b>Похожие</b> на кости голенные,<br>Хозяина-молодца, веселящегося<br>На первом кумысе весеннем<br>Игровые стрелы у него."
    },
    {
        id: "514",
        type: "TYPE_SRAV",
        lines: [ 770 ],
        text: "Сайыҥҥы саамал кымыска ооньньуур<br>Улуу тайах кыыл саннын уҥуоҕун<br>Субуйа тардан ылбыт <b>курдук</b>,<br>Сандалы көмүс оноҕостордоох эбит.",
        translate: "<b>Похожие</b><br>На кости плечевые лося<br>Поры летних кумысов шипящих<br>Серебряные стрелы светлые."
    },
    {
        id: "515",
        type: "TYPE_SRAV",
        lines: [ 774, 4500 ],
        text: "Булка-алка туттар<br>Тииньньит ыал дьиэтин<br>Тиэритэ кэбиэлээбит <b>курдук</b>,<br>Тимир тэмэлгэн оноҕостордоох эбит.",
        translate: "<b>Похожие</b> на опрокинутые ударом одним<br>Хаты-времянки охотника,<br>Железные стрелы могущие<br>Есть у него."
    },
    {
        id: "516",
        type: "TYPE_SRAV",
        lines: [ 778 ],
        text: "Балыксыт ыалым<br>Барайан-сарайан оҥостубут<br>Мас балаҕанын<br>Таҥнарыта аньньыалаабыт <b>курдук</b>,<br>Мас маалтааныка оноҕостордоох эбит.",
        translate: "<b>Похожие</b> на балаганы деревянные рыбака,<br>Легко сношенные ударом,<br>С широкой головкой деревянные стрелы<br>Есть у него."
    },
    {
        id: "517",
        type: "TYPE_SRAV",
        lines: [ 783 ],
        text: "Этиһиигэ-охсуһууга туттар оноҕоһо<br>Илин өттүгэр торбос быарын <b>саҕа</b><br>Хара бөлүөх хаан<br>Туора быллаччы ытырыылаах,<br>Кэлин өттүгэр турар киһи <b>саҕа</b><br>Субай хаан сөгөлөөннөөх,<br>Өһөх төбө, хаан бас,<br>Тимир тиҥсилики,<br>Сылбырҕа кутурук<br>Күүстээх дьорҕой оноҕостоох эбит.",
        translate: "Стрела для брани жестокой – <br>В передней части лежит поперек<br>Сгусток черной крови<br><b>Величиной</b> с печень теленка,<br>Сзади течёт, сопровождая,<br><b>В человечий рост</b> горячая кровь – <br>Всюду проникает стрела,<br>С хвостом вертким."
    },
    {
        id: "518",
        type: "TYPE_SRAV",
        lines: [ 796 ],
        text: "Илэ-бодо иэйээхсиккэ <b>тэҥнэбиллээх</b><br>Үтүө киһи эбит диэммин...",
        translate: "Такой ведь человек<br>На самом деле <b>подобен</b><br>Иэйиэхсит-духу наяву..."
    },
    {
        id: "519",
        type: "TYPE_SRAV",
        lines: [ 845 ],
        text: "Хаҥас диэкки өттүгэр<br>Хаар маҕан баттахтаах,<br>Хабайакаан <b>курдук</b> эттээх,<br>Халааннаах саҥалаах,<br>Күбэй хаан хотун ийэтэ",
        translate: "Если бы родился от матери,<br>Увидел б слева многоголосую,<br>Высокородную мать-госпожу<br>С косами белее снега,<br>С телом чистым,<br><b>Как</b> куропатка..."
    },
    {
        id: "520",
        type: "TYPE_SRAV",
        lines: [ 866 ],
        text: "Халдьаайы тыа маһын <b>курдук</b><br>Хамаандата суох,<br>Куула тыа ойуурун <b>курдук</b><br>Оруолдьута суох эбит.<br>Уҥа диэкки өттүгэр<br>Тоҕус уон субан туруйа <b>курдук</b><br>Уолаттара суох.<br>Хаҥас диэкки өттүгэр<br>Сэттэ уон тыһы кыталык <b>курдук</b><br>Кыргыттара суох эбит.",
        translate: "Команды <b>как</b> лес<br>На косогоре не имеет,<br>Не имеет сопровождения<br><b>Как</b> лес на правой<br>Солнечной стороне,<br>Справа не стоят,<br><b>Как</b> журавли отборные,<br>Парни удалые,<br>Слева не видны<br>Девицы, <b>подобные</b><br>Птицам-стерхам."
    },
    {
        id: "521",
        type: "TYPE_SRAV",
        lines: [ 955, 3972 ],
        text: "Тыҥ тыһы бараах түөһүн <b>курдук</b><br>Кылбайа хатан таҕыста,<br>Халлаан атыыр бараах түөһүн <b>курдук</b><br>Арылла сырдаата.",
        translate: "Утренняя заря поднялась<br>Светясь нежно, <b>словно</b> грудь<br>Самки кулика болотного,<br>Горизонт раскрываетсяч,<br><b>Как</b> грудь полевого петушка."
    },
    {
        id: "522",
        type: "TYPE_SRAV",
        lines: [ 982 ],
        text: "Халааныскай ыстаанын иитин төлө тардан,<br>Элгээн күөл уутун <b>курдук</b><br>Ииктээн эҥиһитэ турда.",
        translate: "Приспустил широкие штаны<br>Начал лить мочу,<br><b>Как</b> поток пойменный."
    },
    {
        id: "523",
        type: "TYPE_SRAV",
        lines: [ 988 ],
        text: "Соҕуруу халлаан соҕуруу улахатыттан,<br>Эриэн элэмэс сылгы<br>Тириитин тиирэ тарпыт <b>курдук</b>,<br>Иэримэ-дьиэримэ былыттар<br>Иэнигийэн таҕыстылар,",
        translate: "Из-под южного горизонта<br>Выплывают быстро облака,<br>Пёстрые, <b>словно</b> растянули<br>Шкуру пёстрого коня."
    },
    {
        id: "524",
        type: "TYPE_SRAV",
        lines: [ 998 ],
        text: "Ити кэнниттэн,<br>Тыстаах баттахтаах сырҕан эһэ<br>Тириитин тиирэ тарпыт <b>курдук</b>,<br>Уулаах най-хара былыт<br>Өрө сүүрэн таҕыста.",
        translate: "Затем, <b>будто</b> растянули вдруг<br>Шкуру черного медведя–<br>С лапами и мехом,<br>Черная туча ринулась вверх,"
    },
    {
        id: "525",
        type: "TYPE_SRAV",
        lines: [ 1035 ],
        text: "Кыһыл көмүс кыламанын быыһыттан<br>Имин быһаҕаһыгар дылы<br>Икки хараҕын уута,<br>Курустаал чөмчүүк <b>курдук</b>,<br>Кылбайа сүүрэ сытта.",
        translate: "Меж ресницами золотыми,<br><b>Словно</b> хрустальные капли,<br>Текут слезы из глаз."
    },
    {
        id: "526",
        type: "TYPE_SRAV",
        lines: [ 1212 ],
        text: "Соҕуруу диэки соноҕос сылгы<br>Дьохсооттуу турарын <b>курдук</b><br>Урааньньыктаах дуурай маҕан тумулугар<br>Өрө сиэтэн дэллэкэччитэн таһааран...",
        translate: "На южной стороне<br>К светлой высоте, имеющей<br>Посередине светлый проход,<br>К высокой горе, похожей<br>На молодого жеребца, <b>будто</b><br>Готовится к прыжку,<br>Быстро привел..."
    },
    {
        id: "527",
        type: "TYPE_SRAV",
        lines: [ 1269 ],
        text: "От-мас иэн иҥиирин <b>курдук</b><br>Таҥнары сыыйыллан барда.<br>Үөһэ дойдуттан, бороҥ куобах баттаҕын<br>Хайыта сыспыт <b>курдук</b>,<br>Муустаах буордаах<br>Тобурах хаар<br>Түһэн туналыппытынан барда.",
        translate: "Растения стали вырываться с корнями,<br><b>Словно</b> жилы сухие,<br>Сверху, с неба высокого <br>Повалил град со снегом, <br><b>Будто</b> растерзали шкуру <br>Серого зайца, смешав <br>С землёй со льдом..."
    },
    {
        id: "528",
        type: "TYPE_SRAV",
        lines: [ 1295 ],
        text: "Үс баһыгар былыргы киһи хотуурун<br>Туруору охсон тахсыбытын <b>курдук</b><br>Үс чай дьойуо тумустаах эбит.<br>Бу үс баһа баҕадьы<br>Үс чаан олгуй <b>саҕа</b> эбит.<br>Үс баһыгар үс чааскы <b>саҕа</b><br>Үс харахтаах баҕайы эбит.<br>Үс хос быһычча быһах <b>курдук</b>,<br>Тимир чыллырыыт түүлээх.<br>Тэлэмэн тыс <b>курдук</b> кынаттаах,<br>Түгэх туоһун төлө үктээбит <b>курдук</b><br>Буруо түптэлээх кутуруктаах эбит.<br>Икки атаҕар уон харалаабыт аньньыыны<br>Хардарыта туппут <b>курдук</b><br>Уон тимир лааҕыра тыҥырахтаах эбит.",
        translate: "На каждой голове <br>Торчат, <b>как</b> косы сенокосные <br>Старинные клювы большие, <br>Три головы, <b>как</b> три <br>Огромных чанов старинных, <br>На каждой голове, <br>По три глаза, <b>как</b> <br>Три чаши большие, <br>Тройные оперения железные, <br><b>Как</b> острые ножи, <br>Крылья, <b>словно</b> шкуры <br>Развернутые, <br><b>Словно</b> дымокур большой, <br>Вьётся хвост, <br>На лапах обеих <br>Когти страшные, <b>словно</b> <br>Десять закаленных ледорубов <br>Расположили косыми рядами."
    },
    {
        id: "529",
        type: "TYPE_SRAV",
        lines: [ 1419 ],
        text: "Тоҕус мастаах оҥочону<br>Умсары бырахпыт <b>курдук</b><br>Сабарай таас уллуҥахтаах эбит,<br>Түөһүн бүттэҕиттэн мүччү сүүрэн түспүт<br>Былаа хара биир эрэ илиилээх эбит,<br>Муус харбыыр хоппо күрдьэх <b>курдук</b><br>Хомуһуннаах куорай далай соҕотох ытыстаах,<br>Сыыр сиҥнибитин <b>курдук</b><br>Сылластыгас сымыһахтаах,<br>Быраан быстыбытын <b>курдук</b><br>Былластыгас уостаах,<br>Хайа хайдыбытын <b>курдук</b><br>Ханьньастыгас айахтаах.<br>Икки таҥалайыттан хардарыта үүнэн киирбит<br>Баай ыал арбыйалаах дьаастыгын<br>Хардарыта туппут <b>курдук</b><br>Дьэбиннээх күөх наалый тиистээх,<br>Уолбут ойбон <b>курдук</b> оҥойо сытыйбыт<br>Суо-соҕотох таныы үүттээх,<br>Сирэйин хабыллар хаба оттотугар<br>Көлүйэ күөл көспүтүн <b>курдук</b><br>Көмүскэ оруннаах,<br>Көмүскэтин хаба оттотугар<br>Дэриэтиньньик киһи дьэс тэриэлкэтин<br>Тиэрэ таппыт <b>курдук</b><br>Дьэбиннээх сиикэй эт бэргэ харахтаах,<br>Хараҕын үрүт өттүгэр<br>Өрүскэ киһи үтэһэтин <b>курдук</b><br>Тимир дьалааҥкы кыламаннаах,<br>Төбөтүн оройугар сатыы ойууру<br>Өрт уота быһыта салаан барбытын <b>курдук</b><br>Абына-табына баттахтаах.",
        translate: "А ступня <b>подобна</b> <br>Опрокинутой вниз лодке <br>Из девяти досок, <br>Из середины груди <br>Выросла черная рука <br>С ладонью огромной, <br><b>Что</b> короб для льда. <br><b>Подобно</b> оползню с горы <br>Безобразная харя, <br>Кривой рот <b>подобен</b> <br>Трещине на горе, <br>С твердого нёба выросли <br>Вверх и вниз зубы, <br><b>Подобные</b> заступам большим, <br>Синим от ржавчины. <br>Единственная ноздря едва <br>Виднеется, <b>как</b> прорубь высохшая, <br>В самой середине лица <br>Различается основание глаза, <br><b>Подобное</b> дну ушедшего пруда, <br>Посередине этого, <b>будто</b> <br>Перевернули медную тарелку <br>Нечистого духа, остался <br>Глаз, <b>как</b> сырая рана, <br>Над глазом торчат <br><b>Как</b> вертела жадного <br>Железные ресницы, <br>На макушке торчат <br>Редкие волосы, <b>будто</b> деревья <br>После пожара в мелком лесу."
    },
    {
        id: "530",
        type: "TYPE_SRAV",
        lines: [ 1461 ],
        text: "Тоҕус уон бууттаах<br>Мунду муҥхатын <b>саҕа</b><br>Борук хара ыстааннаах.",
        translate: "В чёрно-серых штанах<br><b>Величиной</b> с невод для мунду,<br>Весом пудов в девяносто."
    },
    {
        id: "531",
        type: "TYPE_SRAV",
        lines: [ 1476 ],
        text: "Үҥүү батас <b>курдук</b><br>Үтүрү-батары көрөн кэбистэ,<br>Быһах хатат <b>курдук</b><br>Быһа-таһа көрөн кэбистэ.",
        translate: "Взглянул глазами остро,<br><b>Словно</b> лезвием меча,<br><b>Будто</b> собирается тотчас<br>Резать-кромсать."
    },
    {
        id: "532",
        type: "TYPE_SRAV",
        lines: [ 1525 ],
        text: "Борооску баһын <b>саҕа</b> сутуругун<br>Болточчу тутан кэбистэ,<br>Барык бэс салаатын <b>курдук</b><br>Ынырыктаах ыдьыа-быдьыа харытын<br>Өрө тутан кэбистэ.",
        translate: "Поднял запястье корявое,<br><b>Что</b> старой сосны ствол,<br>Начал удары наносить<br>Кулаком огромным,<br><b>Что</b> голова быка."
    },
    {
        id: "533",
        type: "TYPE_SRAV",
        lines: [ 1595 ],
        text: "Устата биллибэт Улаабыр муораны<br>Тордуйалаах уу <b>курдук</b><br>Тобуктарын хараҕар дылы<br>Тоҕута тэпсэн таһаардылар.<br>Арылы хара далай күөлүн <br>Атыйахтаах уу <b>курдук</b><br>Ньайбалдьыччы тэпсэн бардылар.",
        translate: "Великое море Улаабыр <br>Стало по колени им, <br><b>Словно</b> вода в тордуйе, <br>Воды черного омута бездонного, <br><b>Как</b> вода в атыйахе, <br>Колыхается под ногами,"
    },
    {
        id: "534",
        type: "TYPE_SRAV",
        lines: [ 1609 ],
        text: "Биһиги киһибит буоллаҕына<br>Икки сотото<br>Тардыылаах оҕус буулаҕатын <b>курдук</b><br>Таҥнары маадьайан түһэн барда,<br>Иэнин иҥиирэ киил мас <b>курдук</b><br>Кэдэрги тардан барда,<br>Хатан мас <b>курдук</b><br>Ханаччы тардан барда...",
        translate: "У нашего человека <br>Две голени ног, <br><b>Как</b> ярмо вола, несущего <br>Тяжелый воз, согнулись, <br>Жилы спинные сокращаются, <br>Туловище гнётся кверху, <br><b>Как</b> дерявое кривое,<br>"
    },
    {
        id: "535",
        type: "TYPE_SRAV",
        lines: [ 1809 ],
        text: "Соноҕос сылгы<br>Дьохсооттоон эрэрин <b>курдук</b>,<br>Ортотунан урааньньыктаах<br>Дуурай маҕан тумулун үрдүгэр<br>Өрө сүүрэн таҕыста.",
        translate: "Взбежал на белую гору, <br>С белой полосой посередине, <br>Стоящую, <b>как будто</b> жеребец собирается <br>Прыгнуть в схватку."
    },
    {
        id: "536",
        type: "TYPE_SRAV",
        lines: [ 1514 ],
        text: "Иннигиттэн көрдөххө иһэх <b>саҕа</b> эбиккин, <br>Кэннигиттэн көрдөххө кэһэх <b>саҕа</b> эбиккин.",
        translate: "Посмотреть спереди – <br>Ты <b>с</b> грязь из-под копыта, <br>Посмотреть сзади – <br>Ты <b>с</b> нагар из котла."
    },
    {
        id: "537",
        type: "TYPE_SRAV",
        lines: [ 1549 ],
        text: "Сэттэ уон бууттаах<br>Бэт тимир дэлэмир мээчигинэн<br>Хараарар хара быара буолаарай диэн,<br>Хаһыытыы-хаһыытыы тамнааттаан истэ,<br>Албын дьахтар алаадьытын <b>курдук</b><br>Хаптаччы барыталаан хааллылар",
        translate: "Семидесятипудовым <br>Литого железа мячами <br>Старается печень поразить, <br><b>Как</b> оладьи бабы скупой <br>Падают наземь мячи."
    },
    {
        id: "538",
        type: "TYPE_SRAV",
        lines: [ 1674 ],
        text: "Хараҕын уута түннүк мууһун <b>курдук</b><br>Лөһүгүрэччи тоҕунна.",
        translate: "Слезы, <b>как</b> лёд с окна, <br>Шумно падают вниз. (абаасы)"
    },
    {
        id: "539",
        type: "TYPE_SRAV",
        lines: [ 1619 ],
        text: "Төбөтүн оройуттан сиэрэ уотун <b>курдук</b><br>Өрө күүрэн таҕыстылар,<br>Хараҕын уота хатат уотун <b>курдук</b><br>Сардырҕаччы таммалыы сырытта,<br>Күүс быччыҥнарын бастара<br>Көмүс луосканы таҥнары туппут <b>курдук</b><br>Логлорута ойон тахсыталаата.",
        translate: "Макушка загорается <br>Зеленым огнем,<br><b>Словно</b> искры от серы,<br>Из глаз сыплются огни, <br><b>Как</b> из кресала, <br>Мускулы бугрятся бурно от напряжения,<br><b>Будто</b> черпалы серебряных ложек."
    },
    {
        id: "540",
        type: "TYPE_SRAV",
        lines: [ 1711 ],
        text: "Силиргэхтээх титирик <b>саҕа</b><br>Чиккэйэн турар сиһин үөһүн<br>Быһа тардан лис гыннаран кэбистэ.",
        translate: "Главную аорту его<br><b>С</b> лиственницу с корнями <br>Шумно порвал."
    },
    {
        id: "541",
        type: "TYPE_SRAV",
        lines: [ 1760, 2854, 5467 ],
        text: "Хоҥкуйар хоолдьуктарыгар дылы<br>Суоракка уган ылбыт <b>курдук</b><br>Балай маҥаас<br>Өлүү харгыйа-хара суордара.",
        translate: "Черные вороны смерти,<br>Белые по шею, <b>словно</b><br>Подержанные в суорате."
    },
    {
        id: "542",
        type: "TYPE_SRAV",
        lines: [ 2007 ],
        text: "Тоҕус киһи туут хайыһарын<br>Туруорута аспыт <b>курдук</b><br>Туруук таас хайатын<br>Өрө сүүрэн таҕыста.",
        translate: "Взбежал на вершину <br>Гранитной скалы, <b>подобной</b> <br>Воткнутой в землю <br>Лыже тунгусской."
    },
    {
        id: "543",
        type: "TYPE_SRAV",
        lines: [243, 2045, 4756 ],
        text: "Үөр туллук<br>Өрө көтөн тахсан эрэрин <b>курдук</b><br>Үлүскэннээх үүт дьөһүөл  ааттыгынан<br>Өрө көтөн таҕыста,<br>Сиэр  сылгы сиэллээх кутуругун<br>Сэлэйэ баттаабыт <b>курдук</b><br>Сиэр күрдьүгэс  ааттыгынан<br>Өрө силэйэн  таҕыста.",
        translate: "Пролетел по стремительному<br>Молочно-белому тракту,<br><b>Напоминающему</b> взлет<br>Стаи белых снегирей;<br>Пролетает по волшебному<br>Серо-зеленому тракту,<br><b>Подобному</b> пышной гриве и хвосту Светло-сивого коня,<br>Растянутым вдоль."
    },
    {
        id: "544",
        type: "TYPE_SRAV",
        lines: [ 2205, 2646, 2820, 3687, 5361 ],
        text: "Ити киһи ити атын үрдүгэр<br>Хадьдьаайыттан көппүт<br>Хара улар <b>курдук</b><br>Хатана түстэ.<br>Куулаттан көппүт<br>Куртуйах улар <b>курдук</b><br>Олоро түстэ.<br>Эниэттэн көппүт<br>Эрдэҕэс улар <b>курдук</b><br>Иилистэ түстэ.<br>Үрүҥ туллук <b>курдук</b><br>Үрдүк мындаатыгар чөмчөрүс гына түстэ.",
        translate: "<b>Как</b> черный глухарь, <br>Взлетевший с проталины весной, <br>Наш человек вознесся вмиг<br>В высокое седло,<br>[<b>Как</b> тетерев,<br>Взлетевший с южного склона,<br>Уселся].<br><b>Вроде</b> тетерке весенней, <br>Уселся на коня, <br><b>Подобно</b> белому снегирю, <br>Ловко уместился."
    },
    {
        id: "545",
        type: "TYPE_SRAV",
        lines: [ 2289 ],
        text: "Торҕо томоон дойдута<br>Көньньүөс торҕону тиирэ таппыт <b>курдук</b><br>Унаарыйан көҕөрөн хаалбыт эбит.<br>Аан ийэ дойдута<br>Хотун дьахтар дьабакатын туоһахтатын <b>курдук</b><br>Төгүрүйэн унаарыйан көстөн хаалбыт.",
        translate: "Щедрая родимая страна<br>Виднеется вдали, <b>будто</b><br>Растянули шелковые<br>Зеленые полотна вширь,<br>Вся изначальная Мать-страна<br>Виднеется светлым пятном,<br><b>Как</b> роскошный налобник меховой<br>Богатой женщины."
    },
    {
        id: "546",
        type: "TYPE_SRAV",
        lines: [ 2348 ],
        text: "Буор хара атыыр оҕус<br>Буору хаһан<br>Буккулла түһэн сытарын <b>курдук</b>,<br>Модурууннаах модун хаан<br>Модьоҕом иччитэ...",
        translate: "Каменного Порога Дух,<br><b>Подобный</b> черному быку,<br>Погрузившемуся в землю..."
    },
    {
        id: "547",
        type: "TYPE_SRAV",
        lines: [ 2447 ],
        text: "Барбатах балык миинин <b>курдук</b><br>Барыкы-сарыкы дойду буолла,<br>Буспатах мунду миинин <b>курдук</b><br>Борук-сорук дойду буолла,<br>Кэҕэ миинин <b>курдук</b><br>Кимсиин-имсиин сибиирдэр буоллулар.",
        translate: "<b>Будто</b> ненаваристая уха, <br>Такого цвета полумрачная страна оказалась,<br><b>Будто</b> недоваренная уха из гольяна,<br>Такая сумеречная страна оказалась,<br><b>Будто</b> суп из кукушки,<br>Такие студеные земли оказались."
    },
    {
        id: "548",
        type: "TYPE_SRAV",
        lines: [ 2470 ],
        text: "Олорор оҕо <b>саҕа</b><br>Хомурдуостанан барда,<br>Өҕүрүмэр оҕус <b>саҕа</b><br>Күлгэри үөннэннэ,<br>Байтаһын биэ <b>саҕа</b><br>Баҕалаах буолла.",
        translate: "Летают жуки <b>величиной</b><br><b>С</b> младенца сидячего,<br>Резвятся ящерицы <b>с</b> бычка,<br>Прыгают лягушки <b>величиной</b><br><b>С</b> ожиревшую на воле кобылу."
    },
    {
        id: "549",
        type: "TYPE_SRAV",
        lines: [ 2500 ],
        text: "Иннигэр үс курдуулаах<br>Ураһа дьиэ <b>саҕа</b><br>Кутаа уот умайа турар эбит.",
        translate: "Горит костер большой,<br><b>С</b> урасу с тремя опоясками."
    },
    {
        id: "550",
        type: "TYPE_SRAV",
        lines: [ 2540 ],
        text: "Чаан-олгуй <b>саҕа</b> саллайбыт бастаах,<br>Чааскы <b>саҕа</b> күлтэйбит харахтардаах киһи эбит.",
        translate: "Голова, <b>как</b> чан большой,<br><b>Как</b> чашки большие,<br>Выступающие навыкат глаза."
    },
    {
        id: "551",
        type: "TYPE_SRAV",
        lines: [ 2713 ],
        text: "Алаас-сыһыы <b>саҕа</b><br>Араҥас майдааннаах,<br>Көлүйэ күөл <b>курдук</b><br>Үрүҥ көмүс бүрүстүөллээх,<br>Араҥа туос <b>курдук</b><br>Аркыыба кумааҕылаах,<br>Сытар ынах <b>саҕа</b> дьыалалаах,<br>Сымара таас <b>курдук</b> чэрэниилэлээх,<br>Кыдама атырдьах <b>курдук</b> куоссуннаах...",
        translate: "На чистом  майдане,<br><b>Как</b> широкий алас,<br>За престолом серебряным,<br><b>Как</b> озерцо,<br>С архивом из бумаг,<br><b>Как</b> слоистая береста,<br>С делами с лежащую корову,<br>С чернильницей с каменную глыбу,<br>С пером, <b>как</b> вила стогометательная..."
    },
    {
        id: "552",
        type: "TYPE_SRAV",
        lines: [ 3851 ],
        text: "Быарбыттан быстан түспүт<br>Быарым тулаайаҕа <b>холобурдаах</b>,<br>Уон тарбаҕым сүрэҕэр <b>холоонноох</b>,<br>Уот кыымнааҕын <b>кэриэтэ</b>.",
        translate: "Отпавшего от печени частицу,<br><b>Подобную</b> ее сердцевине,<br>Ставшую душой десяти пальцев."
    },
    {
        id: "553",
        type: "TYPE_SRAV",
        lines: [ 3901 ],
        text: "Өрүөллээх көмүс хаччы <b>курдук</b><br>Үрэйэ-сарайа көрбүт,<br>Уулаабатах улаан убаһа <b>курдук</b><br>Унаарыччы көрбүт.	",
        translate: "<b>Как</b> серебряная монета<br>Посмотрела нежным взглядом,<br><b>Подобно</b> жеребенку не напившемуся."
    },
    {
        id: "554",
        type: "TYPE_SRAV",
        lines: [ 4002 ],
        text: "Эттээх сылгы сиэллээх кутуругун<br>Экчи баттаабыт <b>курдук</b><br>Эргэнэ хара тыатыгар<br>Элэйэ-халыйа турда.",
        translate: "Отправился бодро снова<br>В темный лес богатый,<br>Лежащий пышно, <b>подобно</b><br>Поставленным в круг срезанным<br>Гриве и хвосту ретивого жеребца."
    },
    {
        id: "555",
        type: "TYPE_SRAV",
        lines: [ 4092 ],
        text: "Соноҕос сылгы сиэллээх кутуругун<br>Логлорута баттаан ылан<br>Сыыйа-саайа таппыт <b>курдук</b><br>Олохсуйан үүммүт<br>Ойуур хара тыатыгар<br>Сүүрэ-көтө турда.",
        translate: "<b>Будто</b> растянули гриву и хвосты<br>Буйных лошадей, выросших<br>На счастливом раздолии,<br>Побежал весело, играючи<br>За добычей щедрой."
    },
    {
        id: "556",
        type: "TYPE_SRAV",
        lines: [ 4124 ],
        text: "Үүс тириитэ үллүк <b>саҕа</b><br>Бэргэһэтин кырыыбалыы ууруммут.",
        translate: "<b>С</b> накидку из рысьей шкуры<br>Шапку надел набрекень."
    },
    {
        id: "557",
        type: "TYPE_SRAV",
        lines: [ 4270 ],
        text: "Эрбии биитин, ини-бии <b>курдук</b><br>Тэбис-тэҥ дьон буолан биэрдилэр.",
        translate: "По виду оказались равны,<br><b>Как</b> братья родные.<br><b>Как</b> зубья навостренной пилы."
    },
    {
        id: "558",
        type: "TYPE_SRAV",
        lines: [ 4345 ],
        text: "Иэн иҥиирин <b>курдук</b><br>Эрийсэ-сыыйса сырыттылар.",
        translate: "<b>Словно</b> жилы сухие<br>Переплетаются, сплетаются."
    },
    {
        id: "559",
        type: "TYPE_SRAV",
        lines: [ 4388 ],
        text: "Хааным хааппыла <b>саҕа</b><br>Хаалыар диэри охсуһа туруом!",
        translate: "До последней крови <b>с</b> каплю<br>Буду биться насмерть!"
    },
    {
        id: "560",
        type: "TYPE_SRAV",
        lines: [ 4493 ],
        text: "Туруук таас хайатын<br>Үрэн-үрэн көрдөххө,<br>Үрүҥ хоруоҥка <b>саҕа</b> суох гына<br>Үнтү тэптэрэн кэбистэ.",
        translate: "От этого гранитная скала<br>Взорвалась вся, даже<br><b>С</b> белую бусинку не осталось от нее."
    },
    {
        id: "561",
        type: "TYPE_SRAV",
        lines: [ 4499, 4523, 4685 ],
        text: "Улахан үрэх тоҕойдуу түһэн турарын курдук<br>Хомуһуннаах кураахтаах саатын<br>Эмиэ нөҥүө кулгаах тааһыттан<br>Нөҥүө кулгаах тааһыгар дылы<br>Иэмэх <b>курдук</b> иҥнэри тардан турда.",
        translate: "Волшебный лук, изогнутый <br>Подобно излучине большой реки,<br>Наклонил, натянув тетиву от уха до уха,<br><b>Подобно</b> податливому дереву."
    },
    {
        id: "562",
        type: "TYPE_SRAV",
        lines: [ 4509 ],
        text: "Илин диэкки эндэр таас хайатын<br>Үрэн-үрэн көрдөххө<br>Үрүҥ күүгэс <b>саҕа</b> суох гына<br>Үнтү ытан кэбистэ.",
        translate: "Восточную скалу гранитную <br>Взорвал всю с основания,<br>Даже <b>с</b> слепень белую остатка<br>Как ни смотри, не увидишь."
    },
    {
        id: "563",
        type: "TYPE_SRAV",
        lines: [ 4888, 4993 ],
        text: "Сытар ынах <b>саҕа</b><br>Дьыала  кумааҕыны<br>Сыымайдыы олордулар,<br>Араҥа туос <b>курдук</b><br>Аркыыба  кумааҕыны<br>Арыйа олордулар.",
        translate: "Начали рассматривать бумаги, Сложенные в дело <b>величиной</b><br><b>С</b> полный живот лежащей коровы, Листают архивные бумаги,<br><b>Подобные</b> кипе бересты."
    },
    {
        id: "564",
        type: "TYPE_SRAV",
        lines: [ 5035 ],
        text: "Анды  сымыытын <b>курдук</b>Араҕас илгэни хармааныгар угунна,",
        translate: "Положила себе  в  карман <br>Желтую благодать, <b>похожую</b><br>На яйцо утки-синьги."
    },
    {
        id: "565",
        type: "TYPE_SRAV",
        lines: [ 5175 ],
        text: "Үс үрүҥ көмүс бүлүүсэ <b>курдук</b><br>Сирэйин күлүгэ үҥкүүлүү турар эбит.",
        translate: "Лицо лежащего отражается<br>В чистом серебряном потолке<br>Пляшущим образом, <b>подобно</b> Серебряному блюдцу."
    },
    {
        id: "566",
        type: "TYPE_SRAV",
        lines: [ 5312 ],
        text: "Харгыйа хаан аартык айаҕын <b>саҕа</b><br>Айах быһыыта арылынна.",
        translate: "Открылась страшная  пасть,<br><b>Подобная</b> пропасти бездонной."
    },
    {
        id: "567",
        type: "TYPE_SRAV",
        lines: [ 5534 ],
        text: "Сыҥааҕын тыаһа<br>Икки суоруна таас хайа<br>Утарыта быстан түспүтүн <b>курдук</b><br>«Лаас» гына сыыһа ыстаан кэбистэ,<br>Кураанаҕы ытыран хаалла.",
        translate: "Страшилище отпустило челюсти<br>С таким шумом, <b>будто</b><br>Столкнулись две гранитные скалы, Пытаясь проглотить всадника,<br>Но опоздал обманутый,<br>Страшно щелкнули челюсти впустую."
    },
    {
        id: "567_2",
        type: "TYPE_SRAV",
        lines: [ 5540 ],
        text: "Бу киһи бу киирэн<br>Саар булгуньньах <b>курдук</b><br>Сарайа тыыллан барда,<br>Туой булгуньньах <b>курдук</b><br>Туолла үллэн таҕыста.",
        translate: "А внутри желудка<br>И конь, и человек<br>Начали быстро раздуваться,<br><b>Подобно</b> горе земляной."
    },
    {
        id: "567_3",
        type: "TYPE_SRAV",
        lines: [ 6053 ],
        text: "Сирэйин хаба оттотугар баар<br>Улуу оҕус сыарҕатын <b>курдук</b><br>Оҥойо сытыйбыт соҕотох таныы үүттээх.",
        translate: "Единственной зияющей ноздрей <br>В самой середине лица, <br><b>Напоминающей</b> чем-то бычьи сани."
    },
    {
        id: "567_4",
        type: "TYPE_SRAV",
        lines: [ 6300 ],
        text: "Орулуос кус кынатын тыаһын <b>курдук</b><br>«Куус» гына түстүлэр,<br>Түү<b>тээҕэр</b> чэпчэкитик,<br>Ох<b>тооҕор</b> түргэнник<br>Эмдэй-сэмдэй түсүһэн<br>Айаннаан истилэр.",
        translate: "В ушах прогудело что-то,<br><b>Как</b> шум крыльев утки,<br>Гоголь-птицы быстрейшей, <br>Лег<b>че</b> пушинки,<br>Быстр<b>ее</b>  стрелы<br>Летят они рядышком."
    },
    {
        id: "567_5",
        type: "TYPE_SRAV",
        lines: [ 6427 ],
        text: "Аас маҕан сылгы сиэллээх кутуругун<br>Арыйа баттаабыт <b>курдук</b><br>Маҕан дьаралык аартыктаах.",
        translate: "С белым веселым проходом,<br><b>Подобным</b> раскрытым <br>Гривам и хвостам<br>Белых лошадей."
    },
    {
        id: "567_6",
        type: "TYPE_SRAV",
        lines: [ 6464 ],
        text: "Сытар ынах <b>саҕа</b><br>Сымара таас модьоҕом иччитэ,<br>Хаардаах бугул от <b>саҕа</b> саҕаһалаах,<br>Хара тый быарын <b>саҕа</b> хататтаах,<br>Эскэл тый быарын <b>саҕа</b> эстэриилээх...",
        translate: "Каменного Порога Дух,<br><b>Величиной с</b> лежащую корову, Держащий растопку <b>с</b> копну, покрытую снегом, <br>С огнивом <b>с</b> печень крупного жеребенка,<br>С кресалом <b>с</b> молодого коня... (Аан Уххан)"
    },
    /* КҮННЭЭҔИ ОЛОХХО ТУТТУОХХА СӨПТӨӨХ ЭПИЧЕСКЭЙ ФОРМУЛАЛАР (ЭПИЧЕСКИЕ ФОРМУЛЫ ДЛЯ УПОТРЕБЛЕНИЯ В ПОВСЕДНЕВНОЙ РЕЧИ) */
    {
        id: "568",
        type: "TYPE_EPICH",
        lines: [ 1 ],
        text: "Былыргы быһылааннаах дьыл  мындаатыгар,<br>Урукку охсуһуулаах дьыл уорҕатыгар,<br>Алдьархайдаах ааспыт дьыл анараа кытыытыгар...",
        translate: "Буолбута ырааппыт дьыала туһунан (о чем-либо, произошедшем давно)."
    },
    {
        id: "569",
        type: "TYPE_EPICH",
        lines: [ 181 ],
        text: "Сиртэн ситии саҕа ситимнээх,<br>Халлаантан сап саҕа тардыылыктаах...",
        translate: "Туох эмэ ситимин-сибээһин туһунан (о тесной связи чего-либо с чем-либо)."
    },
    {
        id: "570",
        type: "TYPE_EPICH",
        lines: [ 240 ],
        text: "Үс саха онтон үөскээбит,<br>Аҕыс саха онтон аатырбыт...",
        translate: "Норуот үөскээбитин туһунан (о происхождении народа)."
    },
    {
        id: "572",
        type: "TYPE_EPICH",
        lines: [ 275 ],
        text: "Сутуруо быатын саҕа<br>Сутурдаччылаах  оботтоох,<br>Этэрбэс быатын саҕа<br>Идэмэрдээх  иҥсэлээх...",
        translate: "Иҥсэлээх киһи туһунан (о чрезмерно жадном человеке)."
    },
    {
        id: "573",
        type: "TYPE_EPICH",
        lines: [ 283 ],
        text: "Эриллэҕэс илиилэринэн илии баттааннар,<br>Сөрүөстүгэс сөмүйэлэринэн  сөбүлээннэр,<br>Такыр тарбахтарынан таланнар...",
        translate: "Быыбар, биитэр тугу эмэ талыы туһунан (о выборе чего-либо). "
    },
    {
        id: "574",
        type: "TYPE_EPICH",
        lines: [ 332 ],
        text: "Абааһытыгар да тыыттарбатах,<br>Аан дайды айыытыгар да көрдөрбөтөх...",
        translate: "Улаханнык кистээн (тайком от всех и вся)."
    },
    {
        id: "575",
        type: "TYPE_EPICH",
        lines: [ 341 ],
        text: "Сатыы киһи тайаҕын тамнааттыыр,<br>Аттаах киһи кымньыытын быраҕаттыыр...",
        translate: "Бардам киһи туһунан  (об  очень  наглом человека)."
    },
    {
        id: "576",
        type: "TYPE_EPICH",
        lines: [ 386 ],
        text: "Кэлин өттүлэригэр<br>Ньохчойо  сүгэ-сүгэ ньөкөрүстүлэр ,<br>Илин өттүлэригэр<br>Марайа-марайа  көтөҕөн бардылар.",
        translate: "Күүскэ таһар, тиэйэр туһунан (об усиленных погрузочных работах)."
    },
    {
        id: "577",
        type: "TYPE_EPICH",
        lines: [ 436 ],
        text: "Арбаҕаһын бүрүнэн төрөөбүт,<br>Адаҕатын  кэппитинэн кэлбит...",
        translate: "Мөкү майгылаах киһи туһунан (о человеке с дурным характером)."
    },
    {
        id: "578",
        type: "TYPE_EPICH",
        lines: [ 462 ],
        text: "Аҕаларын ууһа бэт айаҕымсах <br>Ийэлэрин ууһа бэт иҥсэлээх...",
        translate: "Аһары ҥсэлээх киһи туһунан (о чрезмерно жадном человеке)."
    },
    {
        id: "579",
        type: "TYPE_EPICH",
        lines: [ 528, 529 ],
        text: "Бириэмэлээх күнүгэр бэлэх биэрэр,<br>Аналлаах күнүгэр ас биэрэр.",
        translate: "Аһы-таҥаһы, малы сөптөөх кэмигэр бэлэхтээһиҥҥэ сыһыаннаах (о своевременном дарении пищи/вещи)."
    },
    {
        id: "580",
        type: "TYPE_EPICH",
        lines: [ 666, 667, 668 ],
        text: "Алын тилэҕэ быһыйга быһыылаах,<br>Оттоку уҥуоҕа бодьуйга  боруобалаах,<br>Үрүт уҥуоҕа модьуга  мөссүөннээх...",
        translate: "Кыахтаах, күүстээх-уохтаах, үчүгэй физическэй туруктаах киһи туһунан (о сильном, физически хорошо сложенном человеке)."
    },
    {
        id: "581",
        type: "TYPE_EPICH",
        lines: [ 673, 674, 675, 676],
        text: "Суллаабыт тиит  курдук сотолоох,<br>Уолах мас  курдук уллуктаах,<br>Хастаабыт мас  курдук харылаах,<br>Бысталаабыт тиит курдук былчыҥнаах...",
        translate: "Кыахтаах, күүстээх, үчүгэй физическэй туруктаах киһи туһунан (о сильном, физически хорошо сложенном человеке)."
    },
    {
        id: "582",
        type: "TYPE_EPICH",
        lines: [ 818 ],
        text: "Үөмэн тиийбэт үрдүк ааттаах,<br>Уунан тиийбэт дьоһун-билэ сурахтаах...",
        translate: "Аатырбыт-сураҕырбыт киһи туһунан (о широко известном человеке)."
    },
    {
        id: "583",
        type: "TYPE_EPICH",
        lines: [ 822 ],
        text: "Аһыныылаах санаалаах,<br>Арҕаһыттан тардыылыктаах<br>Айыы аймаҕын аҥаарыйар үтүөтэ,<br>Көхсүттэн тэһииннээх<br>Көмүскэллээх сүрэхтээх<br>Күн айыы оҕотун<br>Күөгэйэр үтүөтэ...",
        translate: "Сахаларга чулуу киһи туһунан (о ярком представителе народа саха)."
    },
    {
        id: "584",
        type: "TYPE_EPICH",
        lines: [ 829 ],
        text: "Халлаантан түспүтэ буоллар<br>Хаардаах буолуо этэ,<br>Сиртэн тахсыбыта буоллар<br>Буордаах буолуо этэ.",
        translate: "Биллибэт төрүттээх киһи туһунан (о человеке, неизвестного происхождения)."
    },
    {
        id: "585",
        type: "TYPE_EPICH",
        lines: [ 866 ],
        text: "Халдьаайы тыа маһын курдук<br>Хамаандата суох,<br>Куула тыа ойуурун курдук<br>Оруолдьута суох эбит.",
        translate: "Кимниин да билсиспэт-сылдьыспат киһи туһунан (об одиноком человеке)."
    },
    {
        id: "586",
        type: "TYPE_EPICH",
        lines: [ 870 ],
        text: "Уҥа диэкки өттүгэр<br>Тоҕус уон субан туруйа курдук<br>Уолаттара суох.<br>Хаҥас диэкки өттүгэр<br>Сэттэ уон тыһы кыталык курдук<br>Кыргыттара суох эбит.",
        translate: "Соҕотох киһи туһунан (об  одиноком человеке)."
    },
    {
        id: "587",
        type: "TYPE_EPICH",
        lines: [ 876 ],
        text: "Тэҥнээх кэргэнэ диэн<br>Мэличчи биллибэт,<br>Хоойҥо сытар<br>Холоонноох доҕоро<br>Долуой суох киһи эбит.",
        translate: "Сулумах киһи туһунан (о холостяке)."
    },
    {
        id: "588",
        type: "TYPE_EPICH",
        lines: [ 907 ],
        text: "Халыҥ хаһанан хаччы кэбиһэн,<br>Суон саалынан суомас кэбиһэн,<br>Дьоһун мүһэнэн мохсуо уурунан...",
        translate: "Улаханнык үлэлээбэккэ байбыт киһи туһунан (о нечестно разбогатевшем человеке)."
    },
    {
        id: "589",
        type: "TYPE_EPICH",
        lines: [ 941 ],
        text: "Эһэ кыылы иэдэһиттэн илибирэччи тутан,<br>Таба кыылы таныытыттан талыбыраччы тутан,<br>Буур кыылы муннуттан сиэтэн...",
        translate: "Байанайдаах булчут туһунан (об удачливом охотнике)."
    },
    {
        id: "590",
        type: "TYPE_EPICH",
        lines: [ 956 ],
        text: "Тыҥ, тыһы бараах түөһүн курдук,<br>Кылбайа сырдаан кэллэ,<br>Халлаан, атыыр бараах түөһүн курдук,<br>Сырдаан таҕыста.",
        translate: "Сарсыарда халлаан сырдыырын туһунан (о наступлении рассвета, утра)."
    },
    {
        id: "591",
        type: "TYPE_EPICH",
        lines: [ 1025 ],
        text: "Ириэнэх сири иэччэҕин хараҕар дылы<br>Ибили түһэн кэбистэ,<br>Тоҥмут сири тобугун хараҕар дылы<br>Тобулу түһэн кэбистэ.",
        translate: "Күүскэ ыксаан иһэр киһи туһунан (о сильно спешащем человеке)."
    },
    {
        id: "593",
        type: "TYPE_EPICH",
        lines: [ 1049 ],
        text: "Өрөөбүт уоһун өһүлэ олордо,<br>Хоммут уоһун хоҥуннарда...",
        translate: "Киһи сорунуулаахтык саҥаран саҕалаабытын туһунан (о решительно заговорившем человеке)."
    },
    {
        id: "594",
        type: "TYPE_EPICH",
        lines: [ 1051 ],
        text: "Үрүҥ көмүс күөмэйин көбүөхтэттэ,<br>Алтан дьаакыр айаҕын аппаҥнатта...",
        translate: "Киһи саҥаран саҕалаабытын туһунан (о человеке, начавшем разговор)."
    },
    {
        id: "595",
        type: "TYPE_EPICH",
        lines: [ 1056 ],
        text: "Нөҥүө улуус нөрүөннээҕэ,<br>Атын улуус ааттааҕа,<br>Туспа дойду дьоһуннааҕа...",
        translate: "Атын улуус чулуу киһитин туһунан (О выдающемся человеке другого улуса (района))."
    },
    {
        id: "596",
        type: "TYPE_EPICH",
        lines: [ 1071 ],
        text: "Көтөр кынаттаах кыылым<br>Үс төгүл сымыыттаан тиийэр,<br>Сүүрэр атахтаах кыылым<br>Сэттэ төгүл тугуттаан тиийэр...",
        translate: "Олус ыраах сир туһунан (об очень отдаленном месте)."
    },
    {
        id: "597",
        type: "TYPE_EPICH",
        lines: [ 1076 ],
        text: "Кимтэн кииннээххиний,<br>Хантан хааннааххыный,<br>Туохтан тутаахтааххыный...",
        translate: "Киһи төрдүн-ууһун, хантан сылдьарын чопчулааһын (уточнение, откуда родом человек)."
    },
    {
        id: "598",
        type: "TYPE_EPICH",
        lines: [ 1103 ],
        text: "Барар сирим баҕана үүтэ буолла,<br>Кэлэр сирим кэлии үүтэ буолла...",
        translate: "Кыһалҕаҕа ылларбыт, ыксаабыт киһи туһунан (о человеке в безвыходной ситуации)."
    },
    {
        id: "599",
        type: "TYPE_EPICH",
        lines: [ 1105 ],
        text: "Киэҥҥэр хорҕот,<br>Кыараҕаскар кыбыт...",
        translate: "Ыксаан көмө көрдөһүү (мольба о помощи)."
    },
    {
        id: "600",
        type: "TYPE_EPICH",
        lines: [ 1165 ],
        text: "Көмүскүүрүм көмүскэм уута буолла,<br>Харыһыйарым диэн хараҕым уута буолла.",
        translate: "Ыксаан көмө көрдөһүү (мольба о помощи)."
    },
    {
        id: "601",
        type: "TYPE_EPICH",
        lines: [ 1172 ],
        text: "Өлөр күнүм үтүрүйэн кэллэ,<br>Хаалар күнүм хаххалаан кэллэ...",
        translate: "Ыксаан көмө көрдөһүү (мольба о помощи)."
    },
    {
        id: "602",
        type: "TYPE_EPICH",
        lines: [ 1199 ],
        text: "Хойут утуйар дьон<br>Хоһоон оҥосто сылдьыахтара,<br>Эрдэ турар дьон<br>Элэк гына сылдьыахтара...",
        translate: "Дьоҥҥо күлүүгэ-элэккэ киирии туһунан (равнозначно Курам на смех)."
    },
    {
        id: "603",
        type: "TYPE_EPICH",
        lines: [ 1203 ],
        text: "Күөрт ыттар<br>Күлүү гына сылдьыахтара,<br>Эриэн ыттар<br>Элэк гына сылдьыахтара.",
        translate: "Дьоҥҥо күлүүгэ-элэккэ киирии туһунан (равнозначно Курам на смех)."
    },
    {
        id: "604",
        type: "TYPE_EPICH",
        lines: [ 1394 ],
        text: "Биэрдэргин да ылар киһи кэллим,<br>Биэрбэтэргин да ылар киһи кэллим...",
        translate: "Күүһүнэн да ыла кэлбит киһи туһунан (угроза отнять насильно)."
    },
    {
        id: "605",
        type: "TYPE_EPICH",
        lines: [ 1522 ],
        text: "Айаҕыҥ абатын, <br>Бэлэһиҥ бэтэтин, <br>Куолайыҥ сүлүһүнүн...",
        translate: "Куһаҕан, быдьар тыллаах киһи туһунан (об оскорбляющей речи)."
    },
    {
        id: "606",
        type: "TYPE_EPICH",
        lines: [ 1583 ],
        text: "Уйуулаах-хайыылаах тойугу туойдулар, <br>Ыһыылаах-хаһыылаах ырыаны ыллаатылар...",
        translate: "Куһаҕан ырыа-тойук туһунан  (о  пении низкого качества)."
    },
    {
        id: "607",
        type: "TYPE_EPICH",
        lines: [ 1828 ],
        text: "Сүүс киһи сүбэтин<br>Сүбэлэһэ сырыттылар,<br>Отут киһи соргутун<br>Соргулаһа олордулар...",
        translate: "Улахан сүбэлэһии, бэлэмнэнии туһунан (об усиленном обсуждении, подготовке сообща)."
    },
    {
        id: "608",
        type: "TYPE_EPICH",
        lines: [ 2274 ],
        text: "Амнахтаах аартыгы арыйан,<br>Көмнөхтөөх оппуоһу көтөҕөн...",
        translate: "Ыраах сылаалаах айан туһунан (о преодолении долгого пути)."
    },
    {
        id: "609",
        type: "TYPE_EPICH",
        lines: [ 2520 ],
        text: "Суол киһитэ буолан тутайбыт,<br>Сырыы киһитэ буолан сылайбыт...",
        translate: "Ыраах айантан сылайыы туһунан  (об усталости от долгого пути)."
    },
    {
        id: "610",
        type: "TYPE_EPICH",
        lines: [ 2741 ],
        text: "Окко түспүт оҥоһуум,<br>Сиргэ түспүт сэрэбиэйим...",
        translate: "Анал, дьылҕа  туһунан (о предназначеннности, о судьбе человека)."
    },
    {
        id: "611",
        type: "TYPE_EPICH",
        lines: [ 2815 ],
        text: "Одун хаантан оҥоһуулаах,<br>Тыйыс хаантан дьылҕалаах...",
        translate: "Анал, дьылҕа  туһунан (о предназначеннности, о судьбе человека)."
    },
    {
        id: "612",
        type: "TYPE_EPICH",
        lines: [ 3001 ],
        text: "Ыпсыыта суох ырыа диэни<br>Итиннэ ыллыы хааллылар,<br>Туокката суох тойук диэни <br>Онно туойа хааллылар...",
        translate: "Куһаҕан ырыа-тойук туһунан (о  пении низкого качества)."
    },
    {
        id: "613",
        type: "TYPE_EPICH",
        lines: [ 3043 ],
        text: "Хайырҕахтаах хара быара хамсаата,<br>Нохтоолоох тойон сүрэҕэ долгуйда.",
        translate: "Улаханнык долгуйуу туһунан (о сильном волнении, беспокойстве)."
    },
    {
        id: "614",
        type: "TYPE_EPICH",
        lines: [ 3182 ],
        text: "Харахтаах буолларгын көр,<br>Кулгаахтаах буолларгын истэ тарт...",
        translate: "Болҕомто модьуйуута (требование внимания)."
    },
    {
        id: "615",
        type: "TYPE_EPICH",
        lines: [ 3314 ],
        text: "Көрбөтөхпүн көрдүм,<br>Истибэтэхпин иhиттим.",
        translate: "Күүстээх соһуйуу туһунан (о крайнем удивлении)."
    },
    {
        id: "616",
        type: "TYPE_EPICH",
        lines: [ 3391 ],
        text: "Чугаhы хоболооҕунан хомуйдулар,<br>Ырааҕы барабаанынан ынырдылар.",
        translate: "Элбэх дьону ыҥырыы туһунан (о приглашении большого числа людей)."
    },
    {
        id: "617",
        type: "TYPE_EPICH",
        lines: [ 3549 ],
        text: "Уохтаах санааҕын уолуккунан утаар,<br>Күүстээх санааҕын көмөҕөйгүнэн күрэт,<br>Кыыhырбыккын кыырай маҕан халлааҥҥа кыйдаа...",
        translate: "Киһини уоскуйарыгар көрдөһүү туһунан (просьба об успокоении)."
    },
    {
        id: "618",
        type: "TYPE_EPICH",
        lines: [ 3568 ],
        text: "Аhыныылаах санаалаах айыы оҕото,<br>Көмүскэллээх сүрэхтээх күн улууhа...",
        translate: "Үтүө санаалаах киһи туһунан (о добром человеке)."
    },
    {
        id: "619",
        type: "TYPE_EPICH",
        lines: [ 3618 ],
        text: "Көрдөр хараҕым дьүккэтэ буолбут,<br>Көтүрдэр тииhим миилэтэ тэннээх...",
        translate: "Соҕотохтуу  сөбүлүүр, эрэнэр киһилэрин туһунан (об единственном человеке, в которого верят)."
    },
    {
        id: "620",
        type: "TYPE_EPICH",
        lines: [ 3700 ],
        text: "Олоҥхо буолан баран омуннаах,<br>Тыл буолан баран сиикэйдээх...",
        translate: "Омуннаах кэпсээн туһунан (о рассказе с преувеличениями)."
    },
    {
        id: "621",
        type: "TYPE_EPICH",
        lines: [ 3709 ],
        text: "Эрэй бөҕөнү<br>Эҥээриттэн тутан сырыттым,<br>Буруй бөҕөнү<br>Муннуттан тутан сырыттым...",
        translate: "Кыһалҕа, эрэй буулаабытын туһунан (о навалившихся нужде, несчастья)."
    },
    {
        id: "622",
        type: "TYPE_EPICH",
        lines: [ 4867 ],
        text: "Ый ытыыны ытаабыт,<br>Сой-соҥууну соҥообут...",
        translate: "Кыһалҕаҕа, эрэйгэ ылларыы туһунан (о безысходной тоске-печали)."
    },
    {
        id: "623",
        type: "TYPE_EPICH",
        lines: [ 5441 ],
        text: "Биэс тарбаҕым биэриитэ,<br>Уон тарбаҕым уунуута буолар күнэ кэллэ.",
        translate: "Бэлэх-туһах биэрэр түгэн туһунан  (о знаменательной дате)."
    },
]